
import React, {useState, useRef, useEffect, useCallback} from 'react';
import { useTranslation } from 'react-i18next';
import Chat, { Bubble, Image, Icon, toast, useMessages, TypingBubble, Typing, SystemMessage, Divider, Popup, RichText, FileCard, Modal} from '@chatui/core';
import { showToast } from '../toast/Toast';
import CryptoJS from 'crypto-js';


import {marked} from "marked";
import {PopCard, PopDraft} from "../popCard";
import ServiceTicket from "../serviceTicket";
import GoodsEnlist from "../operations/goodsEnlist";
import GoodsRemoval from "../operations/goodsRemoval";
import ArtificialPromotion from "../promotions/ArtificialPromotion";
import GroupBuyingCard from "../promotions/groupBuyingCard";
import GoodsSelect from "../commonUtils/goodsSelect";
import Menu from "../menu/Menu";
import Subsidy from "../promotions/subsidy";
import PromotionOptionsCard from "../promotions/promotionOptionsCard";
import AdvertiseOnPlatform from "../promotions/advertiseOnPlatform";
import ArtificialServiceTicket from "../serviceTicket/ArtificialServiceTicket";
import ManageStore from "../manageStore";
import ChangeOpenHour from "../operations/changeOpenHour";
import SetStoreStatus from "../operations/changeStoreStatus";
import GoodsChange from "../operations/goodsChange";
import InstantDelivery from "../logistics/instantDelivery";
import InputComposer from "./inputComposer/inputComposer";
import promotionOptionsCard from "../promotions/promotionOptionsCard";
import BaseDraftCard from "../commonUtils/baseDraftCard";
import Sidebar from "../sidebar/Sidebar";
import AuthModal from "../authModal/AuthModal";

import Activities from "../activities/Activities";
import Settings from "../settings";
import Profile from "../profile";
import Marketplace from "../marketplace";
import BaseComposer from "../commonUtils/baseComposer/baseComposer";
import conversationStorage from "../../utils/conversationStorage";

import './chatWindow.css';
import { render } from '@testing-library/react';

// 生成临时用户ID的函数
const generateTemporaryUserId = () => {
  // 获取设备信息
  const navigatorInfo = {
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform,
    vendor: navigator.vendor
  };
  
  // 将设备信息转换为字符串
  const deviceString = JSON.stringify(navigatorInfo);
  
  // 使用MD5加密设备信息和当前时间
  const timestamp = Date.now();
  const combinedString = `${deviceString}_${timestamp}`;
  const temporaryId = CryptoJS.MD5(combinedString).toString();
  
  return temporaryId;
};

// 自定义汉堡菜单图标组件（类似 ChatGPT app 的一长一短横线）
const HamburgerIcon = () => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="#070a1d" 
    strokeWidth="2.5" 
    strokeLinecap="round"
    style={{ display: 'block', flexShrink: 0 }}
  >
    {/* 第一条线：长线 */}
    <line x1="3" y1="7" x2="21" y2="7" />
    {/* 第二条线：长线 */}
    <line x1="3" y1="12" x2="21" y2="12" />
    {/* 第三条线：短线（居中） */}
    <line x1="6" y1="17" x2="18" y2="17" />
  </svg>
);

// 深度思考过程展示组件
const ThinkingProcess = ({ thinking, defaultExpanded = false }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const { t } = useTranslation();

  // 当 defaultExpanded 变化时，更新展开状态
  useEffect(() => {
    setIsExpanded(defaultExpanded);
  }, [defaultExpanded]);

  if (!thinking || thinking.trim() === '') return null;

  return (
    <div style={{ 
      marginBottom: '12px', 
      border: '1px solid #e0e0e0', 
      borderRadius: '8px', 
      overflow: 'hidden',
      backgroundColor: '#f9f9f9'
    }}>
      <div 
        onClick={() => setIsExpanded(!isExpanded)}
        style={{ 
          padding: '8px 12px', 
          cursor: 'pointer', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          backgroundColor: '#f0f0f0',
          fontSize: '13px',
          fontWeight: '500',
          color: '#666'
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 16v-4"/>
            <path d="M12 8h.01"/>
          </svg>
          {t('chat.thinkingProcess', '深度思考过程')}
        </span>
        <span style={{ fontSize: '12px', color: '#999' }}>
          {isExpanded ? '▲' : '▼'}
        </span>
      </div>
      {isExpanded && (
        <div style={{ 
          padding: '12px', 
          fontSize: '13px', 
          lineHeight: '1.6', 
          color: '#555',
          maxHeight: '300px',
          overflowY: 'auto',
          whiteSpace: 'pre-wrap'
        }}>
          {thinking}
        </div>
      )}
    </div>
  );
};

// generateConversationTitle will be defined inside component to use i18n

const textType= 'text';
const typingTextType = 'typingBubble';
const preText4Draft = "";
const preText4ServiceTicket = "";


// const baseUrl = 'https://ai-merchant-sit-api.wormwood.ltd'; // 测试环境
const baseUrl = 'https://ai-api.deliverychinatown.com';  // 生产环境
// const baseUrl = 'http://127.0.0.1:8000';

const statusList = {
    "en_us": ["Draft", "Pending", "Released"],
    "zh_cn": ["草稿", "待处理", "已发布"],
};
const intentionList = {
  1: "popDraft",
  2: "subsidyCard",
  3: "advertiseOnPlatform",
  4: "groupBuyingCard",
  5: "advertiseOnPlatform",
  6: "artificialPromotion",
  7: "artificialPromotion",
  8: "artificialPromotion",
  9: "promotionOptionsCard",
  10: "goodsEnlist",
  11: "goodsRemoval",
  12: "goodsChange",
  13: "changeOpenHour",
  14: "setStoreStatus",
  15: "artificialServiceTicket",
  16: "instantDelivery",
  17: "arrange4MultipleOrders",
  18: "inquiry",
  19: "registration",
  20: "artificialServiceTicket",
}

// 默认快捷短语，可选
const defaultQuickReplies = [
  {
    name: 'popDraft',
    code: "popDraft"
  },

];
const user_type_list = ["admin", "merchant", "customer"];
const bot_type = ["**customer service**", "**promotion assistant**", "**operation assistant**"];
const bot_list = ["tangxiaoer", "tangbaobao", "tangshihu"];

// 新加坡节假日列表
const singaporeHolidays = [
  { date: '2026-01-01', name: '新年', nameEn: 'New Year\'s Day' },
  { date: '2026-02-17', name: '农历新年', nameEn: 'Chinese New Year' },
  { date: '2026-02-18', name: '农历新年第2天', nameEn: 'Chinese New Year Day 2' },
  { date: '2026-03-21', name: '开斋节', nameEn: 'Hari Raya Puasa' },
  { date: '2026-04-03', name: '耶稣受难日', nameEn: 'Good Friday' },
  { date: '2026-05-01', name: '劳动节', nameEn: 'Labour Day' },
  { date: '2026-05-27', name: '哈芝节', nameEn: 'Hari Raya Haji' },
  { date: '2026-05-31', name: '卫塞节', nameEn: 'Vesak Day' },
  { date: '2026-06-01', name: '卫塞节 (补假)', nameEn: 'Vesak Day (Observed)' },
  { date: '2026-08-09', name: '国庆日', nameEn: 'National Day' },
  { date: '2026-08-10', name: '国庆日 (补假)', nameEn: 'National Day (Observed)' },
  { date: '2026-11-08', name: '屠妖节', nameEn: 'Deepavali' },
  { date: '2026-11-09', name: '屠妖节 (补假)', nameEn: 'Deepavali (Observed)' },
  { date: '2026-12-25', name: '圣诞节', nameEn: 'Christmas Day' }
];
const ChatWindow = () => {
  
  // console.log('Component mount - localStorage keys:', Object.keys(localStorage));
  // console.log('Component mount - localStorage user:', localStorage.getItem('user'));
  const { t, i18n } = useTranslation();
  const mediaRecorderRef = useRef(null);
  const [audioChunks, setAudioChunks] = useState([]);
  const [recording, setRecording] = useState(false);
  const [sendAudio, setSendAudio] = useState(false);
  const [hasMoreHistory, setHasMoreHistory] = useState(true);
  const [intentionNumber, setIntentionNumber] = useState(0);
  const [typeNumber, setTypeNumber] = useState(1);
  const [botNumber, setBotNumber] = useState(0);
  const [pendingFiles, setPendingFiles] = useState([]); // 待发送的文件数组
  const recordingStartTime = useRef(null);
  const recordingDurationTime = useRef(0);
  const recordingTimerRef = useRef(null);
  const [swipeUpToCancel, setSwipeUpToCancel] = useState(false);
  const [touchStartY, setTouchStartY] = useState(0);
  const assistantInfo = {
    avatar: '/images/tangxiaoer.png',
    name: t('chat.assistantName', 'Tangxiaoer'),
  };
  
  // Menu items with i18n
  const menu = [
    {label: t('chat.menu.promotionService', '促销服务'), value: "promotionOptionsCard"},
    {label: t('chat.menu.everydayOperations', '日常运营'), value: "operationCard"},
    {label: t('chat.menu.logisticsService', '物流服务'), value: "logisticsCard"},
    {label: t('chat.menu.servicesInquiring', '服务咨询'), value: "inquiringCard"}
  ];
  
    // 检查接下来三天内是否有节假日
  const checkUpcomingHolidays = () => {
    const today = new Date();
    const upcomingHolidays = [];

    for (let i = 0; i < 3; i++) {
      const checkDate = new Date(today);
      checkDate.setDate(today.getDate() + i);
      const formattedDate = checkDate.toISOString().split('T')[0];

      const holiday = singaporeHolidays.find(h => h.date === formattedDate);
      if (holiday) {
        // 根据当前语言设置获取对应的节假日名称
        const isChinese = i18n.language.startsWith('zh');
        const holidayWithName = {
          ...holiday,
          displayName: isChinese ? holiday.name : holiday.nameEn
        };
        upcomingHolidays.push(holidayWithName);
      }
    }

    return upcomingHolidays;
  };

  const getInitialMessages = () => {
    // 基础问候语
    let greeting = t('chat.allInOneAssistantGreeting', 'Hello! I\'m your AI Assistant Tangxiaoer, here to provide full support for your store. Whether it\'s marketing, logistics, or store management, I\'m ready to help.');

    // 检查节假日
    const upcomingHolidays = checkUpcomingHolidays();
    if (upcomingHolidays.length > 0) {
      const holidayNames = upcomingHolidays.map(h => h.displayName).join('、');
      const isChinese = i18n.language.startsWith('zh');
      if (isChinese) {
        greeting += `\n **温馨提示**: \n我注意到接下来几天有${holidayNames}，您需要调整店铺营业时间吗？`;
      } else {
        greeting += `\n **Reminder**: \nI notice there are ${holidayNames} in the next few days. Do you need to adjust your store hours?`;
      }
    }
    return [
      {
        type: 'text',
        content: { 
          text: greeting,
          isRich: true
        },
        user: assistantInfo
      }
    ];
  };

  const initialMessages = getInitialMessages();

  // 消息列表
  const { messages, appendMsg, deleteMsg, resetList, prependMsgs, updateMsg } = useMessages(initialMessages);
  
  // 状态声明
  const [openComposer, setOpenComposer] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false); // 弹窗显示状态
  const [isVoiceMode, setIsVoiceMode] = useState(false);
  const [showTextInputAfterVoice, setShowTextInputAfterVoice] = useState(false);
  const [recognizedText, setRecognizedText] = useState('');
  const audioTestInputRef = useRef(null);
  const [user, setUser] = useState(null); // 用户信息，null表示未登录
  const [merchantInfo, setMerchantInfo] = useState(null); // 店铺信息，null表示未加载
  const [merchantInfoError, setMerchantInfoError] = useState(false); // 店铺信息加载是否失败
  const [isLoading, setIsLoading] = useState(true); // 加载状态，防止闪烁

  // Apps下拉菜单状态
  const [appsMenuOpen, setAppsMenuOpen] = useState(false);
  // MD5加密弹窗状态
  const [md5ModalOpen, setMd5ModalOpen] = useState(false);
  const [md5InputText, setMd5InputText] = useState('');
  // 登录提示弹窗状态
  const [loginTipModalOpen, setLoginTipModalOpen] = useState(false);

  // 从本地存储恢复用户信息或生成临时用户ID
  useEffect(() => {
    // console.log('useEffect start - localStorage keys:', Object.keys(localStorage));
    // console.log('useEffect start - localStorage user:', localStorage.getItem('user'));
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      const parsedUser = JSON.parse(savedUser);
      
      // 检查登录状态
      const lastLoginTime = localStorage.getItem('lastLoginTime');
      if (lastLoginTime) {
        // 计算14天的时间戳
        const fourteenDaysInMs = 14 * 24 * 60 * 60 * 1000;
        const currentTime = Date.now();
        const timeDifference = currentTime - parseInt(lastLoginTime, 10);
        
        // 如果超过14天未登录，清除用户信息
        if (timeDifference > fourteenDaysInMs) {
          console.log('Login expired, clearing user data');
          localStorage.removeItem('user');
          localStorage.removeItem('lastLoginTime');
        } else {
          // 登录状态有效，设置用户信息
          setUser(parsedUser);
          return;
        }
      } else {
        // 没有登录时间，但有用户信息，可能是临时用户
        setUser(parsedUser);
        return;
      }
    }
      // 如果没有保存的用户信息，生成临时用户ID
      const temporaryUserId = generateTemporaryUserId();
      const temporaryUser = {
        id: temporaryUserId,
        token: 'guest_token',
        name: 'Guest User',
        role: 'guest',
        createdAt: Date.now()
      };
      // console.log('localStorage user:', localStorage.getItem('user'));
      // console.log('savedUser:', savedUser);
      // 保存临时用户信息到localStorage
      // localStorage.setItem('user', JSON.stringify(temporaryUser));
      // setUser(temporaryUser);
      setIsLoading(false);
  }, []);

  // 当用户信息变化时，保存到本地存储
  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  }, [user]);
  
  // 监听用户信息更新事件
  useEffect(() => {
    const handleUserUpdated = (event) => {
      const newUser = event.detail;
      console.log('收到用户更新事件:', newUser);
      setUser(newUser);
    };
    
    window.addEventListener('userUpdated', handleUserUpdated);
    
    return () => {
      window.removeEventListener('userUpdated', handleUserUpdated);
    };
  }, []);
  const [conversations, setConversations] = useState([]); // 对话列表
  const [currentConversationId, setCurrentConversationId] = useState(null); // 当前对话ID
  const [isNewConversation, setIsNewConversation] = useState(true); // 是否是新对话
  const [bannerVisible, setBannerVisible] = useState(true); // Banner 显示状态
  const [currentPage, setCurrentPage] = useState('chat'); // 当前页面：'chat' 或 'activities'

  const [isIOS, setIsIOS] = useState(false); // 是否是iOS设备

  // 对话管理工具函数
  const generateConversationTitle = (firstMessage) => {
    if (!firstMessage || !firstMessage.content) return t('chat.newChat', '新对话');
    
    const text = typeof firstMessage.content === 'string' 
      ? firstMessage.content 
      : firstMessage.content.text || '';
    
    // 取前50个字符作为标题
    const title = text.trim().substring(0, 50);
    return title || t('chat.newChat', '新对话');
  };

  const [modalOpen, setModalOpen] = useState(false); // 弹窗显示状态
  const [modalFields, setModalFields] = useState([]); // 弹窗中要显示的字段
  const [registerSuccessPopupOpen, setRegisterSuccessPopupOpen] = useState(false); // 注册成功弹窗显示状态


  // 从 IndexedDB 加载对话列表
  useEffect(() => {
    const loadConversations = async () => {
      try {
        // 先尝试从localStorage迁移数据
        await conversationStorage.migrateFromLocalStorage();
        
        // 如果用户未登录，加载游客模式会话
        if (!user) {
          const guestConversation = await conversationStorage.getGuestConversation();
          if (guestConversation) {
            setCurrentConversationId(guestConversation.id);
            setIsNewConversation(false);
            // 加载游客模式对话消息
            resetList(guestConversation.messages || getInitialMessages());
          } else {
            // 游客模式下没有会话记录，使用初始消息
            resetList(getInitialMessages());
            setCurrentConversationId(null);
            setIsNewConversation(true);
          }
          return;
        }
        
        // 用户已登录，从普通会话存储加载会话
        const conversations = await conversationStorage.getAllConversations(user.userId);
        setConversations(conversations);
        
        // 如果有对话，默认选择第一个并加载其消息
        if (conversations.length > 0 && !currentConversationId) {
          const firstConv = conversations[0];
          setCurrentConversationId(firstConv.id);
          setIsNewConversation(false);
          // 加载对话消息
          if (firstConv.messages && firstConv.messages.length > 0) {
            resetList(firstConv.messages);
          }
        } else if (conversations.length === 0 && !currentConversationId) {
          // 没有会话记录，使用初始消息
          console.log('No conversations found, using initial messages');
          resetList(getInitialMessages());
          setCurrentConversationId(null);
          setIsNewConversation(true);
        }
      } catch (error) {
        console.error('Failed to load conversations:', error);
      }
    };
    if (!isLoading){
      loadConversations();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isLoading]);


  // 创建新对话
  const handleNewChat = async () => {
    // 检查是否有用户消息
    const userMessages = messages.filter(m => m.position === 'right');
    if (userMessages.length > 0) {
      console.log('Saving conversation before new chat, user messages:', userMessages.length);
      await saveConversationToHistory();
    } else {
      console.log('No user messages, skipping save');
    }
    resetList(getInitialMessages());
    setCurrentConversationId(null);
    setIsNewConversation(true);
    setSidebarOpen(false);
  };

  // 选择对话
  const handleSelectConversation = async (conversationId) => {
    try {
      // 从IndexedDB获取完整的会话数据
      const conversation = await conversationStorage.getConversation(conversationId, user.userId);
      if (conversation) {
        // 加载对话的消息
        resetList(conversation.messages || getInitialMessages());
        setCurrentConversationId(conversationId);
        setIsNewConversation(false);
        setSidebarOpen(false);
      }
    } catch (error) {
      console.error('Failed to load conversation:', error);
      // 如果从IndexedDB加载失败，尝试从内存中的会话列表加载
      const conversation = conversations.find(c => c.id === conversationId);
      if (conversation) {
        resetList(conversation.messages || getInitialMessages());
        setCurrentConversationId(conversationId);
        setIsNewConversation(false);
        setSidebarOpen(false);
      }
    }
  };

  // 删除对话
  const handleDeleteConversation = async (conversationId) => {
    try {
      console.log('Starting delete conversation:', conversationId, 'user:', user?.userId);
      
      // 先检查当前会话是否有用户消息，如果有，保存一下（虽然要删除了，但为了安全）
      if (currentConversationId === conversationId) {
        const userMessages = messages.filter(m => m.position === 'right');
        console.log('Current conversation has', userMessages.length, 'user messages');
      }
      
      // 从IndexedDB删除会话
      const success = await conversationStorage.deleteConversation(conversationId, user.userId);
      
      console.log('Delete conversation result:', success);
      
      if (success) {
        // 立即重新加载会话列表，确保会话确实被删除了
        const updatedConversations = await conversationStorage.getAllConversations(user.userId);
        console.log('Conversations after deletion:', updatedConversations.length);
        
        // 更新内存中的会话列表
        setConversations(updatedConversations);
        
        // 如果删除的是当前对话，切换到新对话
        if (currentConversationId === conversationId) {
          if (updatedConversations.length > 0) {
            handleSelectConversation(updatedConversations[0].id);
          } else {
            // 如果删除的是最后一条会话，先清空会话ID，再清空消息列表
            console.log('No conversations left after deletion, resetting state');
            setCurrentConversationId(null); // 先设置会话ID为null，避免自动保存
            setIsNewConversation(true);
            setSidebarOpen(false);
            resetList(getInitialMessages()); // 最后重置消息列表
          }
        }
      } else {
        console.error('Failed to delete conversation from IndexedDB');
      }
    } catch (error) {
      console.error('Error deleting conversation:', error);
    }
  };

  // 保存当前对话到历史记录（用于新建聊天前保存）
  const saveConversationToHistory = async () => {
    // 检查是否有用户消息（排除初始的3条消息）
    const userMessages = messages.filter(m => m.position === 'right');
    if (userMessages.length === 0) {
      console.log('No user messages to save');
      return; // 没有用户消息，不保存
    }
    
    const firstUserMessage = userMessages[0];
    const title = generateConversationTitle(firstUserMessage);
    
    // 创建新的对话记录
    // 使用API返回的会话ID，如果没有则生成唯一ID（包含时间戳和随机数）
    const conversationId = currentConversationId || (Date.now().toString() + '-' + Math.random().toString(36).substring(2, 10));
    const conversation = {
      id: conversationId,
      title: title,
      preview: firstUserMessage?.content?.text?.substring(0, 100) || firstUserMessage?.content?.text || '',
      messages: [...messages], // 创建消息数组的副本
      updatedAt: Date.now()
    };

    try {
      if (!user) {
        // 游客模式，保存到游客会话存储
        const success = await conversationStorage.saveGuestConversation(conversation);
        if (success) {
          console.log('Guest conversation saved to IndexedDB:', conversation.title);
        } else {
          console.error('Failed to save guest conversation to IndexedDB');
        }
      } else {
        // 用户已登录，保存到普通会话存储
        const success = await conversationStorage.saveConversation(conversation, user.userId);
        if (success) {
          // 更新内存中的会话列表
          const newConversations = [conversation, ...conversations.filter(c => c.id !== conversationId)];
          setConversations(newConversations);
          console.log('Conversation saved to IndexedDB:', conversation.title);
        } else {
          console.error('Failed to save conversation to IndexedDB');
        }
      }
    } catch (error) {
      console.error('Error saving conversation:', error);
    }
  };

  // 保存当前对话
        const saveCurrentConversation = async () => {
          // 只有当有会话ID时才保存，无论是游客还是登录用户
          if (!currentConversationId) {
            console.log('No conversation ID, skipping automatic save');
            return; // 没有会话ID，不保存
          }
          if (!user || currentConversationId) {
            const firstUserMessage = messages.find(m => m.position === 'right');
            if (!firstUserMessage) return; // 没有用户消息，不保存
            
            const title = generateConversationTitle(firstUserMessage);
            
            // 只使用当前会话ID，不自动生成新的
            const conversationId = currentConversationId;
            const conversation = {
              id: conversationId,
              title: title,
              preview: firstUserMessage?.content?.text?.substring(0, 100) || '',
              messages: messages,
              updatedAt: Date.now()
            };

            try {
              if (!user) {
                // 游客模式，保存到游客会话存储
                const success = await conversationStorage.saveGuestConversation(conversation);
                if (success) {
                  console.log('Guest conversation saved to IndexedDB:', conversation.title);
                } else {
                  console.error('Failed to save guest conversation to IndexedDB');
                }
              } else {
                // 用户已登录，保存到普通会话存储
                const success = await conversationStorage.saveConversation(conversation, user.userId);
                if (success) {
                  // 更新内存中的会话列表
                  const existingIndex = conversations.findIndex(c => c.id === currentConversationId);
                  let newConversations;
                  
                  if (existingIndex >= 0) {
                    // 更新现有对话
                    newConversations = [...conversations];
                    newConversations[existingIndex] = conversation;
                  } else {
                    // 创建新对话
                    newConversations = [conversation, ...conversations];
                  }
                  
                  // 按更新时间排序
                  newConversations.sort((a, b) => b.updatedAt - a.updatedAt);
                  setConversations(newConversations);
                } else {
                  console.error('Failed to save current conversation to IndexedDB');
                }
              }
            } catch (error) {
              console.error('Error saving current conversation:', error);
            }
          }
        };

  // 当消息变化时，自动保存对话
        useEffect(() => {
          const userMessages = messages.filter(m => m.position === 'right');
          
          // 只有当有会话ID且有用户消息时才保存
          if (currentConversationId && userMessages.length > 0) {
            // 延迟保存，避免频繁写入
            const timer = setTimeout(async () => {
              await saveCurrentConversation();
            }, 1000);
            return () => clearTimeout(timer);
          }
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [messages, currentConversationId]);
  
  // 点击外部关闭apps下拉菜单
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (appsMenuOpen) {
        const menu = document.querySelector('.apps-dropdown-menu');
        const customButton = document.querySelector('.custom-apps-button');
        
        if (menu && !menu.contains(event.target) && 
            customButton && !customButton.contains(event.target)) {
          setAppsMenuOpen(false);
        }
      }
    };
    
    document.addEventListener('click', handleClickOutside);
    
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [appsMenuOpen]);

  const startRecording = () => {
    setSendAudio(false);
    setAudioChunks([]);
    setSwipeUpToCancel(false);
    navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
            let mimeType = 'audio/webm';
            mediaRecorderRef.current = new MediaRecorder(stream, { mimeType });
            mediaRecorderRef.current.ondataavailable = event => {
              setAudioChunks(prevChunks => prevChunks.concat(event.data));
            };
            mediaRecorderRef.current.onstop = () => {
              const finalDuration = Math.floor((Date.now() - recordingStartTime.current) / 1000);
              recordingDurationTime.current = finalDuration;
              downloadRecording();
            };
            mediaRecorderRef.current.start();
            setRecording(true);
            recordingStartTime.current = Date.now();
            recordingDurationTime.current = 0;
            recordingTimerRef.current = setInterval(() => {
              const duration = Math.floor((Date.now() - recordingStartTime.current) / 1000);
              recordingDurationTime.current = duration;
            }, 100);
        })
        .catch(console.error);
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setRecording(false);
      if (recordingTimerRef.current) {
        clearInterval(recordingTimerRef.current);
        recordingTimerRef.current = null;
      }
    }
  };

  const downloadRecording = () => {
    const duration = recordingDurationTime.current;
    // console.log("downloadRecording - 录音时长:", duration, "audioChunks长度:", audioChunks.length);
    
    if (duration < 1) {
      showToast(i18n.language === 'zh' ? '说话时间太短' : 'Speaking time too short');
      setAudioChunks([]);
      return;
    }
    
    if (audioChunks && audioChunks.length > 0) {
      // console.log("downloadRecording - 设置sendAudio为true");
      setSendAudio(true);
    }
    else {
      console.log("downloadRecording - audioChunks为空");
      showToast(i18n.language === 'zh' ? '未检测到语音' : 'No audio data');
    }
  };


  const cancelRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop());
    }
    setRecording(false);
    setAudioChunks([]);
    if (recordingTimerRef.current) {
        clearInterval(recordingTimerRef.current);
        recordingTimerRef.current = null;
    }
  }

  const getGoodsList = (merchant_id) => {

    return new Promise((resolve, reject)=>{
      fetch(baseUrl+'/backend-api/get-products-list', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer 123'
        },
        body: JSON.stringify({
          "merchant-id": merchant_id
        })
      }).then(response=>response.json())
          .then(data=> {
            data.goodsList.map((item, index)=>{
               const imgUrl = baseUrl + item.img;
              // const img = URL.createObjectURL();
              item["img"] = imgUrl;
              return item
            })
            resolve(data.goodsList)
          })
          .catch(error=>reject(error));
    })
  }

  // 上传文件到后端
  const uploadFileToServer = (file, fileType) => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('file_type', fileType);
      formData.append('user', user?.id || '');
      formData.append('chatbot_name', 'tangxiaoer');
      
      // 获取用户token
      const loginStatus = checkUserLoginStatus();
      const token = loginStatus.needLogin ? null : user?.token;
      
      fetch(`${baseUrl}/api/upload-file`, {
        method: 'POST',
        headers: {
          'Authorization': token
        },
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        if (data.code===200 && data.imageUrl) {
          resolve(data.imageUrl);
        } else {
          reject(new Error(data.message || '上传失败'));
        }
      })
      .catch(error => {
        reject(error);
      });
    });
  };

  // 删除待发送的文件
  const removePendingImage = (index) => {
    setPendingFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
  };

  // 新的获取商品列表函数，用于管理店铺页面
  const fetchGoodsListForManageStore = (merchantId, page = 1, pageSize = 10) => {
    return new Promise((resolve, reject) => {
      const loginStatus = checkUserLoginStatus();
      if (loginStatus.needLogin) {
        setSidebarOpen(true);
        setAuthModalOpen(true);
        reject(new Error('User not logged in'));
        return;
      }
      console.log(user);
      if (!merchantId) {
        reject(new Error('Merchant ID is required'));
        return;
      }
      
      fetch(`${baseUrl}/backend-api/get-products-list`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': user.token
        },
        body: JSON.stringify({
          "merchant_id": merchantId,
          "page": page,
          "page_size": pageSize
        })
      }).then(response => response.json())
        .then(data => {
          console.log('获取商品列表原始数据:', data);
          
          // 检查响应是否成功
          if (data && data.success && data.data) {
            // 处理图片URL
            const processedGoodsList = data.data.list.map(item => {
              // 处理图片URL，如果有dishImgs字段
              let imgUrl = '';
              if (item.dishImgs) {
                // 如果图片URL不是完整的URL，则添加baseUrl
                if (item.dishImgs.startsWith('http')) {
                  imgUrl = item.dishImgs;
                } else {
                  imgUrl = `https://dec-pub-img.obs.ap-southeast-3.myhuaweicloud.com/${item.dishImgs}`;
                }
              }
              
              // 返回处理后的商品对象，保持与前端组件期望的字段名一致
              return {
                goods_id: item.dishId,
                goods_name: item.dishName || '',
                goods_name_en: item.dishNameEn || '',
                goods_price: item.dishPrice || 0,
                goods_brief: item.dishBrief || '',
                goods_brief_en: item.dishBriefEn || '',
                goods_image: imgUrl,
                category_id: item.categoryId,
                category_name: item.categoryName || '',
                category_name_en: item.categoryNameEn || '',
                is_on_sale: item.isOnSale === 'Y',
                sort_no: item.sortNo || 0,
                picture_label: item.pictureLabel || '',
                restaurant_name: item.restaurantName || ''
              };
            });
            
            // 返回包含分页信息的对象
            resolve({
              goodsList: processedGoodsList,
              pagination: {
                currentPage: data.data.pageNum || page,
                totalPages: data.data.pages || 1,
                totalItems: parseInt(data.data.total) || processedGoodsList.length,
                pageSize: data.data.pageSize || pageSize
              }
            });
          } else {
            // 处理错误响应
            console.error('获取商品列表失败:', data);
            resolve({
              goodsList: [],
              pagination: {
                currentPage: page,
                totalPages: 1,
                totalItems: 0,
                pageSize: pageSize
              }
            });
          }
        })
        .catch(error => {
          console.error('获取商品列表失败:', error);
          reject(error);
        });
    });
  }

  const getMerchantInfo = (token) => {
    return new Promise((resolve, reject) => {
      fetch(baseUrl + '/backend-api/get-merchant-info', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        }
      }).then(response => response.json())
        .then(data => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  }

  const generateServiceTicket = (title, text, table, language="en_us", contentDescription="",  time=undefined, servicer="tangxiaoer", status=0) => {
    return new Promise((resolve, reject)=>{
      try {
        appendMsg({
          type: 'text',
          position: "right",
          content: {text: language==="zh_cn" ? t('chat.okay', '好的') : t('chat.okay', 'Okay')}
        });

        // get current time (Y%-m%-D% H%:M%:S%)
        if (!time) {
          const date = new Date();
          const year = date.getFullYear().toString().padStart(4, "0");
          const month = (date.getMonth() + 1).toString().padStart(2, "0");
          const day = date.getDate().toString().padStart(2, "0");
          const hour = date.getHours().toString().padStart(2, "0");
          const minute = date.getMinutes().toString().padStart(2, "0");
          const second = date.getSeconds().toString().padStart(2, "0");
          time = `${year}-${month}-${day} ${hour}:${minute}:${second}`
        }

        if (language === "en_us") {
          contentDescription = t('chat.serviceTicketDraftEn', 'A Service Ticket draft generated by AI.')
        } else {
          contentDescription = t('chat.serviceTicketDraft', 'AI为您生成了一个工单草稿')
        }
        const serviceTicket = {
                    title: title,
                    text: text,
                    fields: table,
                    status: statusList[language][status],
                    statusList: statusList[language],
                    contentDesc: contentDescription,
                    language: language,
                    servicer: servicer,
                    time: time
                  };
        submitServiceTicket(serviceTicket)
            .then(data=>resolve(data))
            .catch((error)=>reject(error));
      }
      catch (error) {
        reject(error);
      }
    })
  };

  const submitServiceTicket = (serviceTicket) => {

    return new Promise((resolve, reject)=> {
      const loadingMsgId = appendMsg({
        type: 'loading',
        content: { text: '' },
        position: 'left',
        user: assistantInfo
      });
      fetch(baseUrl+'/backend-api/submit-service-ticket', {
        method: 'post',
        headers: {
          'Authorization': "Bearer 123456",
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(serviceTicket)
      }).then(response => {
        return response.json();
      }).then(data => {
        deleteMsg(loadingMsgId);
        if (data.result === 'success') {
          appendMsg({
            type: 'typingBubble',
            content: {text: serviceTicket.language==="zh_cn" ? t('chat.serviceTicketSubmitted', '好的，工单已提交，您可以在**我的->活动**中查看') : t('chat.serviceTicketSubmittedEn', 'Great! Service Ticket has been submitted, you can see it in **Mine->Activities**')},
            user: assistantInfo
          });
          appendMsg({
            type: "serviceTicket",
            content: {
              title: serviceTicket.title,
              text: serviceTicket.text,
              fields: [],//serviceTicket.fields,
              level: data.level,
              levelText: data.levelText,
              status: data.status,
              contentDesc: serviceTicket.contentDesc,
              language: serviceTicket.language,
              servicer: serviceTicket.servicer,
              time: serviceTicket.time,
              timeSpan: getTimeSpan(Date.now(), serviceTicket.language),
              statusList: statusList,
            },
            user: assistantInfo
          });
          resolve(data);
        } else {

          appendMsg({
            type: 'typingBubble',
            content: {text: i18n.language === 'zh' ? t('chat.errorOccurred', '抱歉，出现了一些问题') : t('chat.errorOccurred', 'Sorry, some questions happened')},
            user: assistantInfo
          });
          reject(new Error('Server returned error result'));
        }
      }).catch(error=>{
        deleteMsg(loadingMsgId);
        appendMsg({
            type: 'typingBubble',
            content: {text: i18n.language === 'zh' ? t('chat.errorOccurred', '抱歉，出现了一些问题') : t('chat.errorOccurred', 'Sorry, some questions happened')},
            user: assistantInfo
          });
        console.error('Error submitting service ticket:', error);
        reject(error);
      });
    });
  }
  // 发送回调
  function handleSend(type, val) {
    if (type === 'text' && val.trim()) {
      // 如果是新对话且是第一条用户消息，创建新对话
      // if (isNewConversation && messages.filter(m => m.position === 'right').length === 0) {
      //   const conversationId = Date.now().toString();
      //   setCurrentConversationId(conversationId);
      //   setIsNewConversation(false);
      // }

      appendMsg({
        type: 'text',
        content: { text: val },
        position: 'right',
      });
      const loadingMsgId = appendMsg({
        type: 'loading',
        content: { text: '' },
        position: 'left',
        user: assistantInfo
      });
      fetch(baseUrl+'/api/get_intention', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // 设置请求头
          'Authorization': "bearer app12345"
        },
        body: JSON.stringify({
          query: val,
          user: user.userId,
          conversation_id: "conversation-1"
        }) // 请求体
      }).then(response=>{return response.json()})
          .then(data => {
              console.log(data);
            deleteMsg(loadingMsgId);
            console.log(data.data.outputs.intention_number!==9);
            setIntentionNumber(data.data.outputs.intention_number);
            if (data.data.outputs.intention_number!==9&&data.data.outputs.reply) {
                appendMsg({
                    type: 'text',
                    user: assistantInfo,
                    content: {text: data.data.outputs.reply}
                });
            }
            appendMsg({
              type: intentionList[data.data.outputs.intention_number],
              content: {
                  fields: data.data.outputs.draft,
                  title: data.data.outputs.intention,
                  text: data.data.outputs.description,
                  status: 0,
                  language: data.data.outputs.language,
                  statusList: statusList[data.data.outputs.language]},
              user: assistantInfo
            });

          })
          .catch(error=>{
            deleteMsg(loadingMsgId);
            appendMsg({
              type: 'text',
              content: { text: i18n.language === 'zh' ? t('chat.errorOccurred', '抱歉，出现了一些问题') : t('chat.errorOccurred', 'sorry, some bad questions happened.') },
              position: 'left',
              user: assistantInfo
            });
          })
    }
  }
  // 独立的聊天接口请求函数
  const sendChatRequest = useCallback((val, loadingMsgId, fileInfos=[]) => {
    // 检查用户登录状态
    // const loginStatus = checkUserLoginStatus();
    // if (loginStatus.needLogin) {
    //   // 删除加载消息
    //   deleteMsg(loadingMsgId);
    //   // 打开登录模态框
    //   setSidebarOpen(true);
    //   setAuthModalOpen(true);
    //   return;
    // }
    const imageInfos = fileInfos.filter(item=>item.type==='image');
    // 准备请求参数
    const requestParams = {
      user: user? user.userId: 'guest'+Date.now(),
      user_type: "merchant",
      token: user? user.token: 'guest_token',
      query: val,
      chatbot_name: 'tangxiaoer', // 默认聊天机器人名称
      conversation_id: currentConversationId || '', // 如果没有会话ID则为空
      image_infos: imageInfos, // 如果没有图片则为空数组
      file_infos: fileInfos, // 如果没有文件则为空数组
      intention: ""
    };
    // console.log(requestParams);
    // 发送请求到新的API接口
    fetch(baseUrl + '/api/send', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': user? user.token: 'guest_token'
      },
      body: JSON.stringify(requestParams)
    })
    .then(response => {
      // 删除加载消息
      deleteMsg(loadingMsgId);
      
      // 检查响应是否支持流式处理
      if (!response.body) {
        throw new Error('Response body is not readable');
      }
      
      // 创建一个文本解码器来处理流式响应
      const decoder = new TextDecoder('utf-8');
      const reader = response.body.getReader();
      
      // 用于存储完整的响应文本
      let accumulatedResponse = '';
      // 用于存储消息内容数组
      let messagePart = [{
                    type: 'thought',
                    status: 'loading',
                    title: '问题分析',
                    subtitle: '理解问题',
                    content: ''
                  }];
      
      // 用于存储当前答案
      let currentAnswer = '';
      // 用于存储当前思考内容
      let currentThinkingContent = '';
      // 标记是否正在读取思考内容
      let isReadingThinking = false;
      // 标记当前是否有活跃的思考消息
      let hasActiveThought = true;
      // 标记当前是否有活跃的工具调用消息
      let hasActiveToolCall = false;
      // 用于存储当前的typingBubble消息ID
      let botMessageId = appendMsg({
        type: 'typingBubble',
        content: { messagePart: messagePart, answer: '', isLoading: true },
        position: 'left',
        user: assistantInfo
      });
      // 定时刷新消息，每500ms刷新一次
      const timerId = setTimeout(() => {
        // console.log("定时刷新消息");
        updateMsg(botMessageId, {
          type: 'typingBubble',
          content: { messagePart, answer: currentAnswer, isLoading: true },
          position: 'left',
          user: assistantInfo
        });
      }, 100);
      
      // 存储上一个事件类型的变量，用于去除空换行
      let lastEvent = null;

      // 递归读取流数据
      const readStream = () => {
        return reader.read().then(({ done, value }) => {
          
          if (done) {
            // console.log("流读取完成");
            // 取消定时刷新消息
            clearTimeout(timerId);

            // 流读取完成，将typingBubble转换为text类型以显示最终消息
            updateMsg(botMessageId, {
              type: 'text',
              content: { messagePart, answer: currentAnswer, isRich: true },
              position: 'left',
              user: assistantInfo
            });
            return;
          }
          
          // 解码当前获取的流数据
          const chunk = decoder.decode(value, { stream: true });
          accumulatedResponse += chunk;
          
          // 尝试解析流式返回的JSON内容
          try {
            // 处理每行一个JSON对象的格式（NDJSON）
            const lines = accumulatedResponse.split('\n');
            
            // 处理除最后一行外的所有完整行
            for (let i = 0; i < lines.length - 1; i++) {
              const nowTime = new Date()
              // console.log(nowTime.toLocaleString(), lines[i]);
              // console.log(messagePart);
              if (lines[i].trim()) {
                // console.log(Date.now().toLocaleString(), lines[i]);
                const jsonData = JSON.parse(lines[i]);
                // 更新会话ID
                if (jsonData['conversation_id'] && !currentConversationId) {
                  setCurrentConversationId(jsonData['conversation_id']);
                  setIsNewConversation(false);
                }
                
                // 处理不同类型的事件
                // if (jsonData.event === 'thought_start') {
                //   // 添加一个type=thought的消息内容
                //   messagePart.push({
                //     type: 'thought',
                //     status: 'loading',
                //     title: '问题分析',
                //     subtitle: '理解问题',
                //     content: ''
                //   });
                //   hasActiveThought = true;
                  
                //   // 更新消息
                //   updateMsg(botMessageId, {
                //     type: 'typingBubble',
                //     content: { messagePart, answer: currentAnswer, isLoading: true },
                //     position: 'left',
                //     user: assistantInfo
                //   });
                // }
                //else if (jsonData.event === 'thought_end') {
                if (jsonData.event === 'thought_end') {
                  lastEvent = 'thought_end';
                  // 设置当前thought状态为成功
                  if (hasActiveThought) {
                    const lastThoughtIndex = messagePart.findLastIndex(item => item.type === 'thought');
                    if (lastThoughtIndex !== -1) {
                      messagePart[lastThoughtIndex].status = 'success';
                      hasActiveThought = false;
                    }
                  }
                  
                  // 更新消息
                  updateMsg(botMessageId, {
                    type: 'typingBubble',
                    content: { messagePart, answer: currentAnswer, isLoading: true },
                    position: 'left',
                    user: assistantInfo
                  });
                }
                
                else if (jsonData.event === 'tool_input' && jsonData.tool_input) {
                  lastEvent = 'tool_input';
                  // 提取工具名称数组
                  const toolNames = jsonData.tool_input;
                  // 添加type=tool_call的消息内容
                  messagePart.push({
                    type: 'tool_call',
                    title: '获取关键信息',
                    desc: currentAnswer,
                    tools: toolNames.map(name => ({ name, status: 'pending' }))
                  });
                  // 清空当前答案
                  currentAnswer = '';
                  hasActiveToolCall = true;
                  
                  // 更新消息
                  updateMsg(botMessageId, {
                    type: 'typingBubble',
                    content: { messagePart, answer: currentAnswer, isLoading: true },
                    position: 'left',
                    user: assistantInfo
                  });
                }
                
                else if (jsonData.event === 'call_start' && jsonData.name) {
                  lastEvent = 'call_start';
                  // 提取工具名称，将tool_call中对应工具的状态设置为加载
                  if (hasActiveToolCall) {
                    const lastToolCallIndex = messagePart.findLastIndex(item => item.type === 'tool_call');
                    if (lastToolCallIndex !== -1) {
                      const toolIndex = messagePart[lastToolCallIndex].tools.findIndex(tool => tool.name === jsonData.name);
                      if (toolIndex !== -1) {
                        messagePart[lastToolCallIndex].tools[toolIndex].status = 'loading';
                      }
                    }
                  }
                  
                  // 更新消息
                  updateMsg(botMessageId, {
                    type: 'typingBubble',
                    content: { messagePart, answer: currentAnswer, isLoading: true },
                    position: 'left',
                    user: assistantInfo
                  });
                }
                
                else if (jsonData.event === 'call_success' && jsonData.name) {
                  lastEvent = 'call_success';
                  // 提取工具名称，将tool_call中对应工具的状态设置为成功
                  if (hasActiveToolCall) {
                    const lastToolCallIndex = messagePart.findLastIndex(item => item.type === 'tool_call');
                    if (lastToolCallIndex !== -1) {
                      
                      const toolIndex = messagePart[lastToolCallIndex].tools.findIndex(tool => tool.name === jsonData.name);
                      if (toolIndex !== -1) {
                        messagePart[lastToolCallIndex].tools[toolIndex].status = 'success';
                        const curToolStatus = messagePart[lastToolCallIndex].tools.map(tool => tool.status);
                        if (curToolStatus.every(status => status === 'success')) {
                          hasActiveToolCall = false;
                          messagePart.push({
                            type: 'thought',
                            status: 'loading',
                            title: '正在思考',
                            subtitle: '结合当前信息进行分析',
                            content: '规划下一步行动'
                          });
                          hasActiveThought = true;
                        }
                      }
                    }
                  }
                  
                  // 更新消息
                  updateMsg(botMessageId, {
                    type: 'typingBubble',
                    content: { messagePart, answer: currentAnswer, isLoading: true },
                    position: 'left',
                    user: assistantInfo
                  });
                }

                // 获取消息内容：event为message的json数据的answer属性
                else if (jsonData.event === 'message' && (jsonData.answer!='\n'||lastEvent=='message')) {
                  lastEvent = 'message';
                  // 解析</think> 标签内容
                  let answerText = jsonData.answer;
                  // console.log(answerText);
                  // 检查是否包含</think> 标签
                  if (answerText.includes('<think>')) {
                    isReadingThinking = true;
                    // 移除 <think> 标签
                    answerText = answerText.replace('<think>', '');
                  }
                  
                  if (answerText.includes('</think>')) {
                    isReadingThinking = false;
                    // 提取思考内容并移除标签
                    const thinkEndIndex = answerText.indexOf('</think>');
                    if (thinkEndIndex > 0) {
                      currentThinkingContent += answerText.substring(0, thinkEndIndex);
                      answerText = answerText.substring(thinkEndIndex + 8);
                    } else {
                      currentThinkingContent += answerText;
                      answerText = '';
                    }
                  }
                  
                  // 根据状态决定将内容添加到哪里

                  // 思考状态下，将思考内容添加到当前思考内容
                  if (hasActiveThought) {
                    const lastThoughtIndex = messagePart.findLastIndex(item => item.type === 'thought');
                    if (lastThoughtIndex !== -1) {
                      messagePart[lastThoughtIndex].status = 'success';
                      hasActiveThought = false;
                      if (isReadingThinking) {
                        messagePart[lastThoughtIndex].content += answerText;
                      } 
                    }
                    currentThinkingContent += answerText;
                  } else {
                    // 拼接消息内容
                    currentAnswer += answerText;
                  }
                  
                  // 更新typingBubble消息的内容
                  updateMsg(botMessageId, {
                    type: 'typingBubble',
                    content: { messagePart, answer: currentAnswer, isLoading: true },
                    position: 'left',
                    user: assistantInfo
                  });
                }
                else {
                  lastEvent = null;
                }
              }
            }
            
            // 保留最后一行（可能不完整）用于下一次处理
            accumulatedResponse = lines[lines.length - 1];
          } catch (error) {
            // 解析错误时继续读取流，可能是因为JSON不完整
          }
          
          // 继续读取流
          return readStream();
        });
      };
      
      // 开始读取流
      return readStream();
    })
    .catch(error => {
      // 处理请求错误
      deleteMsg(loadingMsgId);
      console.error('Error sending message to new API:', error);
      appendMsg({
        type: 'text',
        content: { text: i18n.language === 'zh' ? t('chat.errorOccurred', '抱歉，出现了一些问题') : t('chat.errorOccurred', 'sorry, some bad questions happened.') },
        position: 'left',
        user: assistantInfo
      });
    });
  }, [baseUrl, user, currentConversationId, assistantInfo, appendMsg, deleteMsg, updateMsg, setCurrentConversationId, setIsNewConversation, i18n, t])

  
  // 发送文本消息
  const sendTextMessage = useCallback((text, fileInfos = []) => {
    // 添加文本消息到聊天界面
    appendMsg({
      type: 'text',
      content: { text },
      position: 'right',
    });
    
    // 调用聊天接口
    const loadingMsgId = appendMsg({
      type: 'loading',
      content: { text: '' },
      position: 'left',
      user: assistantInfo
    });
    
    sendChatRequest(text, loadingMsgId, fileInfos);
  }, [appendMsg, sendChatRequest, assistantInfo]);

  // 新的发送消息回调函数，调用/api/send接口并处理流式响应
  function handleSendToNewApi(type, val) {
    // 增加用户验证：检查用户登录状态
    // const loginStatus = checkUserLoginStatus();
    // if (loginStatus.needLogin) {
    //   // 打开登录模态框
    //   setSidebarOpen(true);
    //   setAuthModalOpen(true);
    //   return;
    // }
    
    // 检查是否有待发送的文件
    const hasPendingFiles = pendingFiles.length > 0;
    
    // 检查文本消息是否为空
    const hasTextMessage = type === 'text' && val.trim();
    
    // 如果没有文件且文本为空，则不发送
    if (!hasTextMessage) {
      return;
    }
    
    // 如果有文件，先上传文件再发送文本
    if (hasPendingFiles) {
      uploadFilesAndAppendMsg().then((uploadedPreviewInfos) => {
        // 图片上传完成后发送文本消息
        sendTextMessage(val, uploadedPreviewInfos);
      });
      
    } else{
    // 只有文本消息，直接发送
    sendTextMessage(val);
    }
    
  }
      // 上传文件并发送消息
  const uploadFilesAndAppendMsg = useCallback(async () => {
    return new Promise(async (resolve, reject) => {
      try {
      // 标记所有文件为上传中
      setPendingFiles(prevFiles => 
        prevFiles.map(file => ({ ...file, uploading: true }))
      );
      
      // 逐个上传文件
      const uploadPromises = pendingFiles.map(async (file, index) => {
        const formData = new FormData();
        formData.append('file', file.file);
        
        // 确定文件类型
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'];
        const docExtensions = ['txt', 'doc', 'docx', 'pdf', 'md', 'csv', 'xls', 'xlsx'];
        const fileExtension = file.name.split('.').pop().toLowerCase();
        let fileType = "";
        if (imageExtensions.includes(fileExtension)) {
          fileType = "image";
        } else if (docExtensions.includes(fileExtension)) {
          fileType = "document";
        } else {
          throw new Error(`暂不支持的文件类型: ${fileExtension}`);
        }
        
        formData.append('file_type', fileType);
        formData.append('user', user);
        formData.append('chatbot_name', 'tangxiaoer'); // 假设chatbot_name是固定的tangxiaoer
        
        try {
          const response = await fetch(baseUrl + '/api/upload-file', {
            method: 'POST',
            headers: {
              'Authorization': user.token,
            },
            body: formData
          });
          
          if (!response.ok) {
            throw new Error(`上传失败: ${response.statusText}`);
          }
          
          const result = await response.json();
          
          // 解析返回的dify_response和backend_response
          const difyResponse = result.dify_response;
          const backendResponse = result.backend_response;
          const difyWorkflowResponse = result.dify_workflow_response;
          
          // 确定预览URL：对于图片使用backend_response.imageUrl，对于文档使用dify_response.source_url
          // let previewUrl = null;
          let previewInfo = {};
          if (fileType === 'image' && backendResponse && backendResponse.imageUrl) {
            previewInfo = {
              type: 'image',
              id: difyWorkflowResponse.id,
              url: backendResponse.imageUrl,
              imagePath: backendResponse.filePath,
            };
          } else if (difyResponse && difyResponse.source_url) {
            previewInfo = {
              type: 'document',
              id: difyResponse.id,
              size: difyResponse.size,
              name: difyResponse.name,
            };
          }
          
          // 更新文件状态为上传完成，保存dify_response信息
          setPendingFiles(prevFiles => 
            prevFiles.map((f, i) => 
              i === index ? { 
                ...f, 
                previewInfo: previewInfo,
                uploading: false,
                difyInfo: difyResponse,
                backendInfo: backendResponse
              } : f
            )
          );
          
          return previewInfo;
        } catch (error) {
          console.error('文件上传失败:', error);
          // 更新文件状态为上传失败
          setPendingFiles(prevFiles => 
            prevFiles.map((f, i) => 
              i === index ? { ...f, uploading: false, error: error.message } : f
            )
          );
          throw error;
        }
      });
      
      // 等待所有图片上传完成
      const uploadedPreviewInfos = await Promise.all(uploadPromises);
      
      // 添加图片消息到聊天界面
      uploadedPreviewInfos.forEach(previewInfo => {
        if (previewInfo.type === 'image') {
          appendMsg({
            type: previewInfo.type,
            content: {picUrl: previewInfo.url},
            position: 'right',
          });
          // 删除url
          delete previewInfo.url;
        } else if (previewInfo.type === 'document') {
          appendMsg({
            type: previewInfo.type,
            content: {name: previewInfo.name, size: previewInfo.size},
            position: 'right',
          });
        }
      });
      
      // 清空待发送文件数组
      setPendingFiles([]);
      resolve(uploadedPreviewInfos);
    } catch (error) {
      console.error('上传文件时出错:', error);
      alert('文件上传失败，请重试');
      reject(error);
    }
  });
  }, [pendingFiles, appendMsg, user, baseUrl]);
  const transferToHuman = (latestN=10) =>{
      // get latest N pieces of messages,
      return new Promise((resolve, reject)=>{

          const onCancel = ()=>{reject("cancel")};
          const latest = messages.slice(messages.length-latestN, messages.length);
          const contactingMsgId = appendMsg({
              type: 'transferToHuman',
              user: assistantInfo,
              content: {onCancel: onCancel, once: true}
          })

          fetch(baseUrl+"/backend-api/transfer-to-human", {
              method: "post",
              headers: {
                  "Authorization": "Bearer app123abc",
                  "Content-Type": "application/json"
              },
              body: JSON.stringify({
                  record: latest
              })
          }).then(response=> {
              deleteMsg(contactingMsgId);
              return response.json()
          }).then(data=>{
              if (data.result==="success"){
                  appendMsg({
                      type: 'system',
                      content: {text: i18n.language === 'zh' ? t('chat.humanServiceServing', '人工客服 {{csId}} 正在为您服务', { csId: data.cs_id }) : t('chat.humanServiceServing', 'human service {{csId}} is serving for you now', { csId: data.cs_id })}
                  });
                  resolve(data);
              }
              reject(data);
          }).catch(error=>{
              deleteMsg(contactingMsgId);
              appendMsg({
                  type: 'system',
                  content: { text: i18n.language === 'zh' ? t('chat.errorContactingHuman', '抱歉，联系人工客服时出现问题') : t('chat.errorContactingHuman', 'sorry, some bad questions happened in contacting human service.') },
                  position: 'left',
                  user: assistantInfo
              });
              reject(error);
          })

      })
  }
  // 快捷短语回调，可根据 item 数据做出不同的操作，这里以发送文本消息为例

  function handleQuickReplyClick(item) {
    // 点击菜单项时隐藏 banner
    setBannerVisible(false);
    appendMsg({
      type: item.code,
      position: "left",
      user: assistantInfo,
      content: { status: 0 },
    })
  }

    const msgRef = useRef(null);


  // 存储工单标题和描述的状态变量
  const [ticketTitle, setTicketTitle] = useState('');
  const [ticketDescription, setTicketDescription] = useState('');

  const openModal = useCallback((event) => {
    // 从点击按钮所在消息中的draft-container中提取字段数据
    const target = event.target;
    // 找到最近的dify-draft-reply容器
    const draftReply = target.closest('.dify-draft-reply');
    
    if (draftReply) {
      // 获取工单标题和描述
      const cardTitleElement = draftReply.querySelector('.CardTitle-title');
      const cardTextElement = draftReply.querySelector('.card-text');
      
      if (cardTitleElement) {
        setTicketTitle(cardTitleElement.textContent);
      }
      
      if (cardTextElement) {
        setTicketDescription(cardTextElement.textContent);
      }
      
      const draftContainer = draftReply.querySelector('.draft-container');
      if (draftContainer) {
        const fields = [];
        
        // 尝试解析新的JSON格式
        const draftContent = draftContainer.textContent || draftContainer.innerText;
        try {
          // 清理内容，移除可能的多余空格和换行
          const cleanContent = draftContent.trim();
          if (cleanContent.startsWith('{') && cleanContent.endsWith('}')) {
            // 这是新的JSON格式
            const parsedData = JSON.parse(cleanContent);
            // 遍历所有字段
            Object.values(parsedData).forEach(fieldData => {
              if (fieldData && typeof fieldData === 'object') {
                const { name, value, type, description, format: formatStr } = fieldData;
                let format = {};
                
                // 解析format字符串
                if (formatStr) {
                  try {
                    format = JSON.parse(formatStr);
                    // 处理options字符串（如果是字符串形式的数组）
                    if (format.options && typeof format.options === 'string') {
                      format.options = JSON.parse(format.options);
                    }
                    
                  } catch (error) {
                    console.error('解析format字符串失败:', error);
                  }
                }

                // 转换为baseComposer所需的格式
                if (format.options && Array.isArray(format.options)) {
                  // 检查是否需要显示为单选按钮
                  if (['radio', 'select'].includes(type)) {
                    format.options = format.options.map(option => ({
                      label: option,
                      value: option
                    }));
                  }
                }
                
                fields.push({
                  name,
                  type,
                  value,
                  description: description || '',
                  format
                });
              }
            });
          } 
        } catch (error) {
          console.error('解析draft-container内容失败:', error);
        }
        setModalFields(fields);
        setModalOpen(true);
      }
    }
  }, []);

  const submitForm = useCallback((formData, title, description) => {
    // 输出工单标题和描述
    const currentTitle = title || ticketTitle;
    const currentDescription = description || ticketDescription;
    
    // 将modalFields转换为字符串格式
    const ticketFieldsText = modalFields.map(field => {
      let fieldValue = field.value;
      if (Array.isArray(fieldValue)) {
        fieldValue = fieldValue.join(', ');
      } else if (typeof fieldValue === 'object' && fieldValue !== null) {
        fieldValue = JSON.stringify(fieldValue);
      }
      return `${field.name}: ${fieldValue}`;
    }).join('\n');
    
    // 构造提交消息
    const submitMessage = i18n.language === 'zh' ? "提交" : "Submit"
    const fullMessage = `${submitMessage}\n${ticketFieldsText}`
    
    // 添加用户消息到聊天窗口
    appendMsg({
      type: 'text',
      position: "right",
      content: { text: submitMessage },
    })
    
    // 显示加载状态
    const loadingMsgId = appendMsg({
      type: 'loading',
      content: { text: '' },
      position: 'left',
      user: assistantInfo
    });
    
    // 直接调用新的聊天接口请求函数
    sendChatRequest(fullMessage, loadingMsgId);

    // 你的提交逻辑
    console.log('提交表单:', ticketFieldsText);
  }, [modalFields, ticketTitle, ticketDescription]);

  // 处理弹窗中字段值的变化
  const handleFieldChange = useCallback((index, value) => {
    setModalFields(prev => {
      const newFields = [...prev];
      newFields[index].value = value;
      return newFields;
    });
  }, []);

  useEffect(() => {
    const chatContainer = msgRef.current.ref.current;
    
    if (!chatContainer) return;
    const handleClick = (e) => {
      const target = e.target;
      // 检查是否是带有特定data属性的元素
      if (target.hasAttribute('data-chat-action')) {
        e.preventDefault();

        const action = target.getAttribute('data-chat-action');

        switch(action) {
          case 'open-modal':
            openModal(e); // 传递事件对象
            break;
          case 'submit-form':
            // 处理表单提交
            // 找到最近的dify-draft-reply容器
            const draftReply = target.closest('.dify-draft-reply');
            let currentTicketTitle = '';
            let currentTicketDescription = '';
            
            if (draftReply) {
              // 获取工单标题和描述
              const cardTitleElement = draftReply.querySelector('.CardTitle-title');
              const cardTextElement = draftReply.querySelector('.card-text');
              
              if (cardTitleElement) {
                currentTicketTitle = cardTitleElement.textContent;
                setTicketTitle(currentTicketTitle);
              }
              
              if (cardTextElement) {
                currentTicketDescription = cardTextElement.textContent;
                setTicketDescription(currentTicketDescription);
              }
            }
            
            // 调用submitForm并传递标题和描述
            submitForm({}, currentTicketTitle, currentTicketDescription);
            break;
          case 'custom-function':
            // 调用全局函数
            const actionData = target.getAttribute('data-action-data');
            if (window.chatActions && window.chatActions[actionData]) {
              window.chatActions[actionData]();
            }
            break;
        }
      }

      // 处理按钮点击
      if (target.closest('[data-btn-action]')) {
        const btn = target.closest('[data-btn-action]');
        const btnAction = btn.getAttribute('data-btn-action');
        console.log('按钮动作:', btnAction);
        // 执行相应逻辑
      }
    };

    // 监听所有点击事件
    chatContainer.addEventListener('click', handleClick);

    // 监听表单提交
    const handleSubmit = (e) => {
      console.log("提交工单")
    };

    chatContainer.addEventListener('submit', handleSubmit);

    return () => {
      chatContainer.removeEventListener('click', handleClick);
      chatContainer.removeEventListener('submit', handleSubmit);
    };
  }, [openModal, submitForm]);
  function handleQuickReplyClick(item) {

        appendMsg({
          type: 'popDraft',
          content: {
            language: "zh_cn",
          },
          position: 'left',
          user: assistantInfo
        });
  }

    const getPopupInfo = (popup) => {
        return new Promise((resolve, reject) => {
            fetch(baseUrl + "/backend-api/get-popup-info", {
                method: "post",
                headers: {
                    "Authorization": user.token,
                    "Content-Type": "application/json"
                }, body: JSON.stringify({
                    popup: popup
                })
            }).then(response => response.json())
                .then(data => resolve(data))
                .catch(error => reject(error));
        })
    };

    const generatePopup = (title, text, imgs, details, language = "en_us", status = 0, servicer = assistantInfo.name)=>{
      return new Promise((resolve, reject)=>{
          const loadingMsgId = appendMsg({
            type: 'loading',
            content: { text: '' },
            position: 'left',
            user: assistantInfo
          });
          const popup = {
              title: title,
              text: text,
              timeSpan: getTimeSpan(Date.now(), language),
              lookNum: 0,
              likeNum: 0,
              servicer: servicer,
              details: details,
              image: imgs,
              status: status,
              language: language,
          };

          fetch(baseUrl+"/backend-api/submit-popup", {
              method: "post",
              headers: {
                  "Authorization": user.token,
                  "Content-Type": "application/json"
              }, body: JSON.stringify({
                  popup: popup
              })
          }).then(response=>response.json())
              .then(data=>{
                  deleteMsg(loadingMsgId);
                  appendMsg({
                      type: 'popCard',
                      content: {
                          ...data.popup,
                          status: data.status,
                      },
                      user: assistantInfo
                  });
                  resolve(data);
              })
              .catch(error=>{
                  reject(error);
                  deleteMsg(loadingMsgId);
                  appendMsg({
                      type: 'typingBubble',
                      content: {text: i18n.language === 'zh' ? t('chat.failedSubmitPopup', '抱歉，提交泡泡失败') : t('chat.failedSubmitPopup', 'Sorry, failed to submit POP-UP.')}
                  })
              })
      })
  }
  function renderMarkDown(text) {
    if (!text && text !== 0) return '';
    marked.setOptions({
      gfm: true,
      breaks: true,
    });
    
    const renderer = new marked.Renderer();
    // 自定义链接渲染
    renderer.link = function(href) {
      // console.log(href, title, text);
      return `<a href="${href.href}" title="${href.title || ''}" target="_blank" rel="noopener noreferrer">${href.text}</a>`;
    };
    // 自定义图片渲染
    renderer.image = function(tokens) {
      // console.log(tokens);
      return `<img style="max-width: 100%; height: auto;" src="${tokens.href}" alt="${tokens.text || tokens.href}" title="${tokens.text || ''}">`;
    };
    // 自定义表格渲染
    renderer.table = function(table) {
      // 处理复杂表格数据结构
      let headerHtml = '';
      let bodyHtml = '';
      
      // 生成表头
      if (table.header && table.header.length > 0) {
        headerHtml = '<thead><tr>';
        table.header.forEach((column, index) => {
          const align = column.align || (table.align && table.align[index]) || 'center';
          headerHtml += `<th style="text-align: ${align}; padding: 8px; border: 1px solid #ddd; background-color: #f5f5f5; font-weight: bold;">${column.text}</th>`;
        });
        headerHtml += '</tr></thead>';
      }
      
      // 生成表格主体
      if (table.rows && table.rows.length > 0) {
        bodyHtml = '<tbody>';
        table.rows.forEach((row, rowIndex) => {
          const rowStyle = rowIndex % 2 === 0 ? 'background-color: #fff;' : 'background-color: #f9f9f9;';
          bodyHtml += `<tr style="${rowStyle}">`;
          row.forEach((cell, cellIndex) => {
            const align = cell.align || (table.align && table.align[cellIndex]) || 'center';
            bodyHtml += `<td style="text-align: ${align}; padding: 8px; border: 1px solid #ddd;">${cell.text}</td>`;
          });
          bodyHtml += '</tr>';
        });
        bodyHtml += '</tbody>';
      }
      
      return `<table style="width: 100%; border-collapse: collapse; margin: 10px 0; font-size: 13px;">${headerHtml}${bodyHtml}</table>`;
    };
    // 自定义引用渲染
    renderer.blockquote = function(quote) {
      // console.log(quote);
      return `<blockquote style="margin: 10px 0; padding: 10px; border-left: 4px solid #ccc;">${renderMarkDown(quote.text)}</blockquote>`;
    };
    marked.use({ renderer });
    
    return marked.parse(text);
  }
  const handleMenuClick = (item) => {
      appendMsg({
        type: 'text',
        position: 'right',
        content: {text: item.label}
      });
      appendMsg({
        type: item.value,
        content: item.content,
        user: assistantInfo
      });
    };
  const getTimeSpan = (timeString, language="en_us") => {
      const timeText = {
          "en_us": {
              day: " day ago",
              hour: " hour ago",
              minute: " minute ago",
              second: " second ago"
          },
          "zh_cn": {
              day: "天前",
              hour: "小时前",
              minute: "分钟前",
              second: "秒前"
          }
      }
      const curTime = new Date();
      const oldTime = new Date(timeString);
      const diff = (curTime - oldTime)/1000;
      const days = diff / (24 * 60 * 60);
      if (days>=1) {
            return Math.trunc(days).toString() + timeText[language].day;

      }

      const hours = diff / (60*60);
      if (hours>=1)
          return Math.trunc(hours) + timeText[language].hour;

      const minutes = diff / (60)
      if (minutes>=1)
          return Math.trunc(minutes) + timeText[language].minute;

      return Math.trunc(diff) + timeText[language].second;
  };
  function renderMessageContent(msg) {
    const { type, content, position } = msg;

    // 渲染messagePart数组
    const renderMessagePart = (messagePart) => {
      if (!messagePart || !Array.isArray(messagePart)) return null;
      
      return messagePart.map((part, index) => {
        switch (part.type) {
          case 'thought':
            return (
              <div key={index} className="think-part">
                <div className="think-header">
                  <div className="think-title">
                    {part.title || '问题分析'}
                  </div>
                  <div className="think-status" status={part.status||'error'}>
                    {part.status === 'loading' ? <Icon type="spinner" spin></Icon> :
                     part.status === 'success' ? <Icon type="check-circle"></Icon> : 
                     part.status === 'pending' ? <Icon type="refresh"></Icon> : 
                     <Icon type="warning-circle"></Icon>}
                  </div>
                </div>
                {part.subtitle && (
                  <div className="think-subtitle">
                    {part.subtitle}
                  </div>
                )}
                
                <div className="think-content">
                  {part.content||"确认所需数据"}
                </div>
                
              </div>
            );
          case 'tool_call':
            return (
              <div key={index} className="tool-part">
                <div className="tool-header">
                  <div className="tool-title">
                    {part.title || '工具调用'}
                  </div>
                </div>
                <div className="tool-desc">
                  {part.desc || '正在查询相关信息'}
                </div>
                {part.tools && Array.isArray(part.tools) && part.tools.length > 0 && (
                  <div className="tool-content">
                    {part.tools.map((tool, toolIndex) => (
                      <div key={toolIndex} className="tool-item">
                        <span className="tool-name">
                          {tool.name}
                        </span>
                        <span className="tool-status" status={tool.status}>
                          {tool.status === 'pending' ? <Icon type="refresh"></Icon> : 
                           tool.status === 'loading' ? <Icon type="spinner" spin></Icon> : 
                           tool.status === 'success' ? <Icon type="check-circle"></Icon> : 
                           <Icon type="warning-circle"></Icon>}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          default:
            return null;
        }
      });
    };

    switch (type) {
      case 'topPadding':
          return(
              <div style={{"height": "10px"}}></div>
          )
      case 'typingBubble':

        return (
          <div className="typing-container">
            {position==="right"||!content.messagePart?(null):(
              <div className="front-content">
                {content.messagePart && renderMessagePart(content.messagePart)}
              </div>
            )}
            {content.isLoading?(<Typing className="loading-dot"/>):(null)}
            <TypingBubble
                content={content.answer}
                options={{ step: [2, 4], interval: 20 }}
                isRichText={true}
                messageRender={renderMarkDown}/>
            </div>)
      case 'text':
          return (
            <>
            {position==="right"||!content.messagePart?(null):(
              <div className="front-content">
                {content.messagePart && renderMessagePart(content.messagePart)}
              </div>
            )}
              {content.isRich?(
              <Bubble>
                <RichText content={renderMarkDown(content.answer || content.text)}/>
              </Bubble>):(
              <Bubble content={content.answer || content.text}></Bubble>
              )}
            </>
          )
      case 'image':
        return (
          <Image src={content.picUrl} width="200" height="200" alt="图片名" />
            // <Bubble type="image">
            //   <img  src={content.picUrl} alt="" />
            // </Bubble>
        )
      case 'document':
        return (
          <FileCard file={{name: content.name, size: content.size}}/>
        )
      case 'loading':
        return(
          <div className="typing-container">
              <Typing/>
          </div>
        )
      case 'system':
        return (
            <SystemMessage content={content.text}></SystemMessage>
        )
      case 'parsing':
        return (
            <Typing text={t('chat.parsingVoice', '正在解析语音...')}></Typing>
        )
      case 'divider':
        return (
            <Divider position={"right"}> all</Divider>
        )
      case 'popDraft':
          const desc = content.language==="zh_cn" 
            ? t('chat.popDraftDesc', 'AI已为您生成泡泡内容，可以直接发布或编辑后发布')
            : t('chat.popDraftDescEn', 'A Pop-up draft has been generated by AI, you can publish it directly or edit it before publishing');
          let image = ['/images/laziji.png', '/images/shuizhuyu.png'];
          let title = "title";
          let text = "text";

          // for (let i in content.fields){
          //     if (content.fields[i].type==="image"){
          //         image = content.fields[i].value;
          //     }
          //     if (content.fields[i].type==="text"){
          //         title = content.fields[i].value;
          //     }
          //     else if (content.fields[i].type==="textarea"){
          //         text = content.fields[i].value;
          //     }
          // }
        return (
            <BaseDraftCard
                cardType={"POP-UP"}
                reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                language={content.language}
                height={60}
                popDesc={desc}
                title={title}
                text={text}
                fields={content.fields}
                editable={true}
                popExtraInfo={{
                    status: 'draft',
                    statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft'),
                    image: image,
                }}
                submit={({title, text, image, table, language})=>generatePopup(title, text, image, table, language)}
            />
        )
      case 'popCard':
        return (
            <BaseDraftCard
                title={content.title}
                editable={false}
                text={content.text}
                language={content.language}
                popExtraInfo={{
                    statusText: content.language==="zh_cn" ? t('chat.released', '已发布') : t('chat.released', 'Released'),
                    image: content.image
                }}
                bottomInfo={[
                    {icon: "servicer-o", text: content.servicer},
                    {icon: "alarm", text: content.timeSpan},
                    {icon: "check", text: content.lookNum},
                    {icon: "thumbs-up", text: content.likeNum}
                ]}
            />
        )
      case 'operationCard':
        const operationItems = {
          [t('chat.menuManagement', '菜单管理')]: [
            { label: t('chat.addNewProducts', '添加新商品'), value: 'Add New Products' },
            { label: t('chat.removeProducts', '移除商品'), value: 'Remove Products' },
            { label: t('chat.changeProducts', '修改商品'), value: 'Change Products' }],
          [t('chat.storeManagement', '店铺管理')]:[
            { label: t('chat.changeStoreStatus', '更改店铺状态'), value: 'Change Store Status' },
            { label: t('chat.changeOpenHour', '更改营业时间'), value: 'Change Open Hour' },
          ]
        };

        return (
            // <OperationCard title={"运营操作选项"} text={"目前支持以下运营选项，点击选择。"} operationItems={operationItems}></OperationCard>
            <PromotionOptionsCard
                title={t('chat.operationsTitle', '我们支持以下运营操作：')}
                options={operationItems}
                onOptionClick={(text)=>setInputText(text)}
            ></PromotionOptionsCard>
        )

      case 'serviceTicket':
        return (
            <BaseDraftCard
                cardType={"ServiceTicket"}
                language={content.language}
                title={content.title}
                text={content.text}
                fields={content.fields}
                editable={false}
                serviceTicketExtraInfo={{
                    level: content.level,
                    levelText: content.levelText,
                    trackingNumber: {text: (content.language==="zh_cn" ? t('chat.trackingNo', '工单号 WO-') : t('chat.trackingNo', 'Tracking No. WO-')) + Math.floor(Math.random() * 999999).toString().padStart(6, '0')},
                    status: content.status,
                    statusText: content.language==="zh_cn" ? t('chat.completed', '已完成') : t('chat.completed', 'Completed')
                }}
                bottomInfo={[
                    {icon:'servicer-o', text: 'Tangxiaoer'},
                    {icon:'alarm', text: getTimeSpan(content.time, content.language)},
                ]}
            />
        )
      case 'goodsEnlist':
        return(
            <BaseDraftCard
                cardType={"ServiceTicket"}
                reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                language={content.language}
                title={content.title}
                text={content.text}
                fields={content.fields}
                editable={true}
                serviceTicketExtraInfo={{
                    status: 'draft',
                    statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
                }}
                submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
            />
        )
      case 'goodsRemoval':
        return(
           <BaseDraftCard
                cardType={"ServiceTicket"}
                reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                language={content.language}
                title={content.title}
                text={content.text}
                fields={content.fields}
                editable={true}
                serviceTicketExtraInfo={{
                    status: 'draft',
                    statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
                }}
                submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
            />
        )
      case 'artificialPromotion':
        return (
            <BaseDraftCard
                cardType={"ServiceTicket"}
                reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                language={content.language}
                title={content.title}
                text={content.text}
                fields={content.fields}
                editable={true}
                serviceTicketExtraInfo={{
                    status: 'draft',
                    statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
                }}
                submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
            />
        )
        case 'registration':
            return (
                <BaseDraftCard
                    cardType={"ServiceTicket"}
                    reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                    language={content.language}
                    title={content.title}
                    text={content.text}
                    fields={content.fields}
                    editable={true}
                    serviceTicketExtraInfo={{
                        status: 'draft',
                        statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
                    }}
                    submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
                />
            )
      case 'groupBuyingCard':
        return(
            <BaseDraftCard
                cardType={"ServiceTicket"}
                reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                language={content.language}
                title={content.title}
                text={content.text}
                fields={content.fields}
                editable={true}
                serviceTicketExtraInfo={{
                    status: 'draft',
                    statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
                }}
                submit={({title, text, table, language})=>{
                    return new Promise((resolve, reject) => {
                        // 使用Promise.all等待所有异步操作完成
                        Promise.all([
                            generateServiceTicket(title, text, table, language)
                                .catch(error => {
                                    console.error("Service ticket creation failed:", error);
                                    return { success: false, error };
                                }),
                            generatePopup(title, text, table["Image"], table, language)
                                .catch(error => {
                                    console.error("Popup creation failed:", error);
                                    return { success: false, error };
                                })
                        ]).then(([serviceTicketResult, popupResult]) => {
                            // 检查两个操作的结果
                            const errors = [];

                            if (!serviceTicketResult || serviceTicketResult.success === false) {
                                errors.push(i18n.language === 'zh' ? t('chat.failCreateServiceTicket', '创建团购工单失败') : t('chat.failCreateServiceTicket', 'Fail to create service ticket of group buying'));
                            }

                            if (!popupResult || popupResult.success === false) {
                                errors.push(i18n.language === 'zh' ? t('chat.failCreatePopup', '创建团购泡泡失败') : t('chat.failCreatePopup', 'Fail to create Pop-up of group buying'));
                            }

                            if (errors.length > 0) {
                                reject(errors.join("; "));
                            } else {
                                resolve();
                            }
                        }).catch(error => {
                            reject(i18n.language === 'zh' ? t('chat.unexpectedError', '意外错误：{{message}}', { message: error.message }) : t('chat.unexpectedError', 'Unexpected error: {{message}}', { message: error.message }));
                        });
                    });
                }}
            />
        )
      case 'menu':
        const items = content.items;
        return (
            <Menu
                title={t('chat.servicesTitle', '我支持以下服务：')}
                onItemClick={handleMenuClick}
                items={items}
            ></Menu>
        )
      case 'subsidyCard': // todo 考虑要不要分开
        return (
            <BaseDraftCard
                cardType={"ServiceTicket"}
                reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                language={content.language}
                title={content.title}
                text={content.text}
                fields={content.fields}
                editable={true}
                serviceTicketExtraInfo={{
                    status: 'draft',
                    statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
                }}
                submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
            />
        )
      case 'promotionOptionsCard':
        return (
            <PromotionOptionsCard
              title={t('chat.promotionWaysTitle', '我们支持以下促销方式：')}
              onOptionClick={(text)=>setInputText(text)}
            ></PromotionOptionsCard>
        )
      case 'advertiseOnPlatform':
        return(
            <BaseDraftCard
                cardType={"ServiceTicket"}
                reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                language={content.language}
                title={content.title}
                text={content.text}
                fields={content.fields}
                editable={true}
                serviceTicketExtraInfo={{
                    status: 'draft',
                    statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
                }}
                submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
            />
        )
      case 'inquiringCard':
          const servicesItems = [
              {label: t('chat.services.posPowerBank', 'POS、充电宝'), value: 'typingBubble', content: {text: t('chat.services.posPowerBank', 'POS、充电宝')}},
              {label: t('chat.services.advertisingPromotion', '广告与促销'), value: 'typingBubble', content: {text: t('chat.services.advertisingPromotion', '广告与促销')}},
              {label: t('chat.services.platformServices', '12POP平台有哪些服务？'), value: 'typingBubble', content: {text: t('chat.services.platformServices', '12POP平台有哪些服务？')}},
              {label: t('chat.services.logisticsServices', '物流服务'), value: 'typingBubble', content: {text: t('chat.services.logisticsServices', '物流服务')}},
          ];
        return (
            <Menu
                title={t('chat.servicesTitle', '我支持以下服务：')}
                onItemClick={handleMenuClick}
                items={servicesItems}
            ></Menu>
        )
      case 'inquiry':
        return(
             <TypingBubble
                content={content.fields}
                options={{ step: [1, 6], interval: 50 }}
                isRichText={true}
                messageRender={renderMarkDown}/>
        )
      case 'artificialServiceTicket':
          return(
              <BaseDraftCard
                cardType={"ServiceTicket"}
                reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                language={content.language}
                title={content.title}
                text={content.text}
                fields={content.fields}
                editable={true}
                serviceTicketExtraInfo={{
                    status: 'draft',
                    statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
                }}
                submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
            />
          )

      case 'setStoreStatus':
          return (
              <BaseDraftCard
                cardType={"ServiceTicket"}
                reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                language={content.language}
                title={content.title}
                text={content.text}
                fields={content.fields}
                editable={true}
                serviceTicketExtraInfo={{
                    status: 'draft',
                    statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
                }}
                submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
            />
          )
      case 'changeOpenHour':

          return (
            <BaseDraftCard
                cardType={"ServiceTicket"}
                reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                language={content.language}
                title={content.title}
                text={content.text}
                fields={content.fields}
                editable={true}
                serviceTicketExtraInfo={{
                    status: 'draft',
                    statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
                }}
                submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
            />
          )
      case 'goodsChange': // todo 暂时没想好如何更改
          return(
              <GoodsChange
                language={content.language}
                status={content.status}
                statusList={content.statusList}
                onAcknowledge={(title, text, table, language)=>generateServiceTicket(title, text, table, language)}
              ></GoodsChange>
          )
        case 'transferToHuman':
            return(
                <SystemMessage
                    content={t('chat.contactingHumanService', '正在联系人工客服')}
                    action={{
                        text: t('chat.cancel', '取消'),
                        onClick: content.onCancel,
                        once: content.once
                    }}
                />
            )
        case 'logisticsCard':
            const logisticsItems = {
              [t('chat.arrangeRidersDrivers', '安排骑手/司机')]: [
                { label: t('chat.instantDelivery', '即时配送'), value: 'Instant Delivery' },
                { label: t('chat.arrangementForSeveralOrders', '多单安排'), value: 'Arrangement for Several Orders' }]
            };
            return (
                <PromotionOptionsCard
                    title={t('chat.operationsTitle', '我们支持以下运营操作：')}
                    options={logisticsItems}
                    onOptionClick={(text)=>setInputText(text)}
                ></PromotionOptionsCard>
            )
        case 'instantDelivery':
            return(
                <BaseDraftCard
                    cardType={"ServiceTicket"}
                    reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                    language={content.language}
                    title={content.title}
                    text={content.text}
                    fields={content.fields}
                    editable={true}
                    serviceTicketExtraInfo={{
                        status: 'draft',
                        statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
                    }}
                    submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
                />
            )
        case 'arrange4MultipleOrders':

            return (
                <BaseDraftCard
                    cardType={"ServiceTicket"}
                    reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                    language={content.language}
                    title={content.title}
                    text={content.text}
                    fields={content.fields}
                    editable={true}
                    serviceTicketExtraInfo={{
                        status: 'draft',
                        statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
                    }}
                    submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
                />
            )
        case 'BaseDraftCard':
            const tmpFields = [
                {name: "整数", description: "说明文本说明文本说明文本说明文本说明文本说明文本说明文本说明文本", type: "int", value: 0, format: {maximum: 100, minimum: 0, editable: false}},
                {name: "文本", description: "说明文本", type: "text", value: ""},
                {name: "小数", description: "说明文本", type: "float", value: "5.2"},
                {name: "图片", description: "说明文本", type: "image", value: ['/images/laziji.png', '/images/shuizhuyu.png']},
                {name: "地址", description: "说明文本", type: "address", value: ""},
                {name: "日期", description: "说明文本说明文本说明文本说明文本说明文本说明文本说明文本说明文本说明文本说明文本", type: "date", value: "2025-10-17"},
                {name: "时间", description: "说明文本", type: "time", value: "17:35"},
                {name: "多行文本", description: "说明文本", type: "textarea", value: ""},
                {name: "订单", description: "说明文本", type: "order", value: ""},
                {name: "商品", description: "说明文本", type: "products", value: "", format: {currency: 'xx$'}},
                {name: "单选", description: "说明文本", type: "radio", value: "", format:{options: [{label: "满减", value: 0}, {label: "满赠", value: 1}]}},
                {name: "多选", description: "说明文本", type: "checkbox", value: [], format: {options: [{label: "小红书", value: 0}, {label: "谷歌", value: 1}]}},
                {name: "状态", description: "说明文本", type: "store-status", value: {"2025-11-26": 0}},
            ];
            return (
                <BaseDraftCard
                    // cardType={"POP-UP"}
                    cardType={"ServiceTicket"}
                    reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
                    language={"en_us"}
                    title={"设置店铺状态 Base Card BaseCardBaseCardBaseCardBaseCard Base Card Base Card Base Card Base Card Base Card "}
                    text={" Card Text Card Text Card Text Card Text Card Text Card Text Card Text ard Text Card Text Card Text Card Text Card Text Card Text Card Text"}
                    fields={tmpFields}
                    editable={true}
                    serviceTicketExtraInfo={{
                        level: 'high',
                        levelText: '中',
                        trackingNumber: {text: (i18n.language === 'zh' ? t('chat.trackingNo', '工单号 WO-') : t('chat.trackingNo', 'Tracking No. WO-')) + Math.floor(Math.random() * 999999).toString().padStart(6, '0')},
                        status: 'progress',
                        statusText: "进行中 预计完成时间2025/11/11"
                    }}
                    popExtraInfo={{
                        statusText: "泡泡状态",

                    }}
                    bottomInfo={[
                        {icon:'servicer-o', text: 'Tangxiaoer'},
                        {icon:'check', text: 543},
                        {icon:'thumbs-up', text: 178},
                        {icon:'alarm', text: getTimeSpan("2025-11-20 18:00:00", "en_us")},
                    ]}
                    popDesc={"AI已为您生成泡泡内容"}
                ></BaseDraftCard>
            )
      default:
        return null
    }
  }
  // todo 需要用数据库来存储用户的聊天记录，SQLite, indexedDB等
  const handleLeftClick = () => {
    setSidebarOpen(true);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  // 检查用户是否需要登录
  const checkUserLoginStatus = () => {
    // 如果没有用户信息，需要登录
    if (!user) {
      return { needLogin: true, reason: 'no_user' };
    }
    
    // 检查上次登录时间
    const lastLoginTime = localStorage.getItem('lastLoginTime');
    if (!lastLoginTime) {
      return { needLogin: true, reason: 'no_login_time' };
    }
    
    // 计算14天的时间戳（14天 * 24小时 * 60分钟 * 60秒 * 1000毫秒）
    const fourteenDaysInMs = 14 * 24 * 60 * 60 * 1000;
    const currentTime = Date.now();
    const timeDifference = currentTime - parseInt(lastLoginTime, 10);
    
    // 如果超过14天未登录，需要重新登录
    if (timeDifference > fourteenDaysInMs) {
      return { needLogin: true, reason: 'expired' };
    }
    
    // 不需要登录
    return { needLogin: false, reason: 'valid' };
  };

  const handleLoginClick = () => {
    setAuthModalOpen(true);
  };

  const handleLogin = async (credentials) => {
    // 实际的登录API调用
    console.log('Login attempt:', credentials);
    
    try {
      // 使用MD5加密密码
      const encryptedPassword = CryptoJS.MD5(credentials.password).toString();
      
      // 调用登录API
      const response = await fetch(baseUrl + '/backend-api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: credentials.username,
          password: encryptedPassword
        })
      });
      
      // 处理响应
      if (response.ok) {
        const data = await response.json();
        console.log('Login success:', data);
        
        // 设置用户信息
        const newUser = {
          // name: data.data.username,
          // merchantId: data.data.merchantId,
          token: data.data.token,
          userId: data.data.userId,
          // refreshToken: data.data.refreshToken,
          // merchantType: data.data.shopType,
        };
        
        // 立即保存用户信息到localStorage（不依赖useEffect）
        console.log('Login: Setting user in localStorage:', newUser);
        localStorage.setItem('user', JSON.stringify(newUser));
        
        // 更新状态
        setUser(newUser);
        
        // 保存登录时间
        localStorage.setItem('lastLoginTime', Date.now().toString());
        console.log('Login: localStorage after setting user:', localStorage.getItem('user'));
        
        // 关闭登录模态框和侧边栏
        setAuthModalOpen(false);
        setSidebarOpen(false);
      } else {
        // 登录失败处理
        const errorData = await response.json();
        console.error('Login failed:', errorData);
        alert('登录失败：' + (errorData.message || '用户名或密码错误'));
      }
    } catch (error) {
      // 网络错误处理
      console.error('Login error:', error);
      alert('登录出错：' + error.message);
    }
  };

  const handleRegister = async (userData) => {
    // 实际的注册API调用
    console.log('Register attempt:', userData);
    
    try {
      const response = await fetch(baseUrl + '/backend-api/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "userName": userData.username,
          "userEmail": userData.email,
          "userPhone": userData.userPhone,
          "shopName": userData.shopName,
          "shopAddress": userData.shopAddress,
          "city": userData.city,
          "country": userData.country,
          "countryCode": userData.countryCode,
          "phoneAreaCode": userData.phoneAreaCode,
          "recommender": userData.recommender
        })
      });
      
    //   const data = await response.json();
    //   if (response.ok && data.success) {
    //     // 注册成功，自动登录
    //     setUser({
    //       name: userData.username,
    //       avatar: null
    //     });
    //     setAuthModalOpen(false);
    //     setSidebarOpen(false);
    //     // 使用弹窗替换alert
    //     setRegisterSuccessPopupOpen(true);
    //   } else {
    //     // 注册失败
    //     console.error('Register error:', data);
    //     alert('注册失败：' + (data.msg || '未知错误'));
    //   }
    } catch (error) {
      console.error('Register network error:', error);
      alert('注册出错：' + error.message);
    }
  };

  const handleLogout = () => {
    // 登出时保存当前会话并加载游客会话
    const logoutAndLoadGuestSession = async () => {
      // 1. 先保存当前会话（如果是游客会话）
      if (user && user.role === 'guest') {
        const userMessages = messages.filter(m => m.position === 'right');
        if (userMessages.length > 0) {
          await saveCurrentConversation();
        }
      }
      
      // 2. 清除用户信息和登录状态
      setUser(null);
      setSidebarOpen(false);
      // If on settings page, return to chat
      if (currentPage === 'settings') {
        setCurrentPage('chat');
      }
      
      // 3. 清除缓存功能
      if ('caches' in window) {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
      }
      
      // 4. 清除localStorage中除了游客会话之外的所有数据
      const keysToPreserve = ['chat_conversations']; // 只保留chat_conversations
      Object.keys(localStorage).forEach(key => {
        if (!keysToPreserve.includes(key)) {
          localStorage.removeItem(key);
        }
      });
      
      // 5. 清除sessionStorage所有数据
      sessionStorage.clear();
      
      // 6. 生成或获取游客用户信息
      const temporaryUserId = generateTemporaryUserId();
      const temporaryUser = {
        id: temporaryUserId,
        token: 'guest_token',
        name: 'Guest User',
        role: 'guest',
        createdAt: Date.now()
      };
      
      // 7. 保存游客用户信息到localStorage
      localStorage.setItem('user', JSON.stringify(temporaryUser));
      setUser(temporaryUser);
      
      // 8. 加载IndexedDB中的游客聊天记录
      const guestConversation = await conversationStorage.getGuestConversation();
      if (guestConversation) {
        setCurrentConversationId(guestConversation.id);
        setIsNewConversation(false);
        // 加载游客模式对话消息
        resetList(guestConversation.messages || getInitialMessages());
      } else {
        // 游客模式下没有会话记录，使用初始消息
        resetList(getInitialMessages());
        setCurrentConversationId(null);
        setIsNewConversation(true);
      }
    };
    
    logoutAndLoadGuestSession().catch(error => {
      console.error('Error during logout:', error);
      // 如果出错，使用初始消息
      resetList(getInitialMessages());
      setCurrentConversationId(null);
      setIsNewConversation(true);
    });
  };

  const handleDeleteAccount = () => {
    // 删除账户，清除用户信息和相关数据
    // 这里可以添加实际的删除账户API调用
    console.log('Delete account:', user);
    setUser(null);
    setSidebarOpen(false);
    // TODO: 添加实际的删除账户API调用
    // 例如：调用后端API删除用户账户
  };

  const handleAuthModalClose = () => {
    setAuthModalOpen(false);
  };

  const handleActivitiesClick = () => {
    setCurrentPage('activities');
    setSidebarOpen(false);
  };

  const handleMarketplaceClick = () => {
    setCurrentPage('marketplace');
    setSidebarOpen(false);
  };

  const handleSettingsClick = () => {
    setCurrentPage('settings');
    setSidebarOpen(false);
  };

  // 创建加载店铺信息的函数
  const loadMerchantInfo = () => {
    // 检查用户登录状态
    const loginStatus = checkUserLoginStatus();
    if (loginStatus.needLogin) {
      // 打开登录模态框
      setSidebarOpen(true);
      setAuthModalOpen(true);
      return;
    }
    
    if (user && user.token) {
      setMerchantInfoError(false); // 重置错误状态
      getMerchantInfo(user.token)
        .then(response => {
          console.log('Merchant info loaded:', response);
          // 检查响应结构并提取实际数据
          if (response && response.data) {
            // 转换API返回的数据结构为组件需要的格式
            const transformedData = {
              merchant_id: response.data.shopId, // 添加merchant_id字段
              store_name: response.data.shopName,
              store_image: response.data.storeImage || "/images/store-placeholder.png",
              is_open: response.data.inBusiness === 'Y',
              address: response.data.address || "暂无地址信息",
              phone: response.data.phone || "暂无电话信息",
              description: response.data.shopDescription || "暂无描述信息",
              business_type: response.data.merchantBusinessType,
              business_time_desc: response.data.businessTimeDesc,
              business_time_desc_en: response.data.businessTimeDescEn,
              business_time_desc_vn: response.data.businessTimeDescVn,
              min_order_amount: response.data.minOrderAmount,
              shop_type: response.data.shopType,
              balance: response.data.balance,
              points: response.data.points,
              current_month_orders: response.data.currentMonthOrders,
              current_month_cancelled_orders: response.data.currentMonthCancelledOrders,
              current_month_revenue: response.data.currentMonthRevenue,
              // 保留原始数据以备后用
              raw_data: response.data
            };
            setMerchantInfo(transformedData);
            setMerchantInfoError(false);
          } else {
            console.error('Invalid merchant info response:', response);
            setMerchantInfoError(true);
          }
        })
        .catch(error => {
          console.error('Failed to load merchant info:', error);
          setMerchantInfoError(true);
        });
    }
  };

  const handleProfileClick = () => {
    console.log('Profile clicked');
    setCurrentPage('profile');
    setSidebarOpen(false);
    
    // 如果用户已登录且店铺信息未加载，则加载店铺信息
    loadMerchantInfo();
  };

  const handleManageStoreClick = () => {
    console.log('Manage store clicked');
    setCurrentPage('manageStore');
    
    // 如果用户已登录且店铺信息未加载，则加载店铺信息
    loadMerchantInfo();
  };

  const handleBackToChat = () => {
    setCurrentPage('chat');
  };
  const handleAppClick = () => {
    setAppsMenuOpen(!appsMenuOpen);
  };
  
  // 处理MD5加密
  const handleMd5Encrypt = () => {
    setAppsMenuOpen(false);
    setMd5ModalOpen(true);
  };
  
  // 加密并复制到剪贴板
  const handleEncryptAndCopy = () => {
    if (!md5InputText.trim()) {
      alert('请输入要加密的文本');
      return;
    }
    
    const encryptedText = CryptoJS.MD5(md5InputText).toString();
    
    // 复制到剪贴板
    navigator.clipboard.writeText(encryptedText)
      .then(() => {
        alert('已加密并复制到剪贴板');
        setMd5ModalOpen(false);
        setMd5InputText('');
      })
      .catch(err => {
        console.error('复制失败:', err);
        // 降级方案：创建临时文本区域
        const textArea = document.createElement('textarea');
        textArea.value = encryptedText;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        alert('已加密并复制到剪贴板');
        setMd5ModalOpen(false);
        setMd5InputText('');
      });
  };
  const handleMoreClick = () => {
    const newBotNumber = (botNumber+1) % bot_list.length
    setBotNumber(newBotNumber);
    // appendMsg({
    //   type: 'system',
    //   content: { text: '88VIP exclusive intelligent '+ bot_type[newBotNumber]+ ' ' + bot_list[newBotNumber] +' is at your service' },
    //   }
    // );
    appendMsg({
      type: 'typingBubble',
      content: { text: t('chat.botGreeting', '您好，我是您的专属{{botType}} {{botName}}。我能为您做些什么？', { botType: bot_type[newBotNumber], botName: bot_list[newBotNumber] }) },
      position: 'left',
      user: assistantInfo
    });
  };
  const handleHexClick = () => {
    if (localStorage.getItem("conversation-id-"+bot_list[botNumber])==null){
      console.log("no conversation to delete");
      return;
    }
    // console.log("Conversation ID has been cleared.");
    fetch(baseUrl+"/api/delete", {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bear app-xxxx'
      },
      body: JSON.stringify({
        user: user.userId,
        chatbot: bot_list[botNumber],
        conversation_id: localStorage.getItem("conversation-id-"+bot_list[botNumber])
      })
    }).then(async response => {
      if (!response.ok) {
        throw new Error('request failed');
      }
      if (!response.body) {
        throw new Error('Response body is not available');
      }

      response.json().then(data => {
        if (data.result === "success"){
          appendMsg({
            type: 'system',
            content: { text: i18n.language === 'zh' ? t('chat.newConversation', '新对话') : t('chat.newConversation', 'New conversation') },
            });
          window.localStorage.removeItem("conversation-id-"+bot_list[botNumber]);
          resetList(initialMessages);
        }
        else{
          console.log("delete failed: "+data.result)
        }
      });

    })
    .catch(error=>{
      console.log("error: "+error)
    });
  };

  // useEffect(() => {
  //   console.log("current chatbot: "+bot_list[botNumber]);
    // appendMsg({
    //   type: 'system',
    //   content: { text: '88VIP exclusive intelligent '+ bot_type[botNumber]+ ' ' + bot_list[botNumber] +' is at your service' },
    //   }
    // );
    // appendMsg({
    //   type: 'text',
    //   content: { text: 'Hi，I am your exclusive '+ bot_type[botNumber] + ' ' + bot_list[botNumber] +'. What can I do for you?' },
    //   position: 'left',
    //   user: assistantInfo
    // });
  // }, [botNumber, appendMsg]);

  // 替换左上角图标为一长一短横线（类似 ChatGPT app）
  useEffect(() => {
    const replaceHamburgerIcon = () => {
      // 尝试多种选择器
      let leftContent = document.querySelector('.Navbar-leftContent');
      if (!leftContent) {
        leftContent = document.querySelector('[class*="leftContent"]');
      }
      if (!leftContent) {
        // 查找包含 svg 或 use 元素的按钮
        const buttons = document.querySelectorAll('.Navbar button, .Navbar [role="button"]');
        for (let btn of buttons) {
          if (btn.querySelector('svg, use') && btn.closest('.Navbar')) {
            leftContent = btn;
            break;
          }
        }
      }
      
      if (leftContent) {
        // 检查是否已经替换过
        if (leftContent.querySelector('svg.hamburger-menu-icon')) {
          return;
        }
        
        // 清除现有内容（包括所有子元素）
        while (leftContent.firstChild) {
          leftContent.removeChild(leftContent.firstChild);
        }
        
        // 设置样式
        leftContent.style.color = '#070a1d';
        leftContent.style.display = 'flex';
        leftContent.style.alignItems = 'center';
        leftContent.style.justifyContent = 'center';
        leftContent.style.cursor = 'pointer';
        leftContent.style.padding = '8px';
        leftContent.style.borderRadius = '4px';
        leftContent.style.pointerEvents = 'auto'; // 确保可以接收点击事件
        leftContent.style.position = 'relative';
        leftContent.style.zIndex = '12'; // 确保在导航栏和其他元素之上
        
        // 创建汉堡菜单 SVG
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', '24');
        svg.setAttribute('height', '24');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', 'none');
        svg.classList.add('hamburger-menu-icon');
        svg.style.stroke = '#070a1d';
        svg.style.strokeWidth = '2.5';
        svg.style.strokeLinecap = 'round';
        svg.style.display = 'block';
        svg.style.flexShrink = '0';
        svg.style.verticalAlign = 'middle';
        
        // 第一条线：长线
        const line1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line1.setAttribute('x1', '3');
        line1.setAttribute('y1', '7');
        line1.setAttribute('x2', '21');
        line1.setAttribute('y2', '7');
        line1.setAttribute('stroke', '#070a1d');
        line1.setAttribute('stroke-width', '2.5');
        line1.setAttribute('stroke-linecap', 'round');
        
        // 第二条线：长线
        const line2 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line2.setAttribute('x1', '3');
        line2.setAttribute('y1', '12');
        line2.setAttribute('x2', '21');
        line2.setAttribute('y2', '12');
        line2.setAttribute('stroke', '#070a1d');
        line2.setAttribute('stroke-width', '2.5');
        line2.setAttribute('stroke-linecap', 'round');
        
        // 第三条线：短线（居中）
        const line3 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line3.setAttribute('x1', '6');
        line3.setAttribute('y1', '17');
        line3.setAttribute('x2', '18');
        line3.setAttribute('y2', '17');
        line3.setAttribute('stroke', '#070a1d');
        line3.setAttribute('stroke-width', '2.5');
        line3.setAttribute('stroke-linecap', 'round');
        
        svg.appendChild(line1);
        svg.appendChild(line2);
        svg.appendChild(line3);
        leftContent.appendChild(svg);
      }
    };

    // 立即执行一次
    replaceHamburgerIcon();
    
    // 延迟执行以确保 DOM 已渲染
    const timer1 = setTimeout(replaceHamburgerIcon, 50);
    const timer2 = setTimeout(replaceHamburgerIcon, 100);
    const timer3 = setTimeout(replaceHamburgerIcon, 200);
    const timer4 = setTimeout(replaceHamburgerIcon, 500);
    const timer5 = setTimeout(replaceHamburgerIcon, 1000);
    
    // 使用 MutationObserver 监听 DOM 变化
    const observer = new MutationObserver(() => {
      replaceHamburgerIcon();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    // 定期检查（作为备用方案）
    const intervalId = setInterval(replaceHamburgerIcon, 2000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timer4);
      clearTimeout(timer5);
      clearInterval(intervalId);
      observer.disconnect();
    };
  }, []);

  // useEffect(()=>{
  //   console.log("current user: "+user_type_list[typeNumber]);
  // }, [typeNumber]);

  // 监听录音数据的useEffect，当有录音数据时，向后端的语音转文本接口发送语音数据，并接收识别的文本。
  useEffect(() => {
    if (sendAudio && audioChunks.length>0 && user) {
      // console.log("开始发送语音数据，audioChunks长度:", audioChunks.length);
      const audioBlob = new Blob(audioChunks, {type: "audio/mp3"});
      // console.log("音频Blob大小:", audioBlob.size, "字节");
      const formData = new FormData();
      formData.append("file", audioBlob);
      formData.append("user", user.userId);

      fetch(baseUrl+"/api/speech-to-text", {
        method: 'post',
        headers: {
          'Authorization': user.token
        },
        body: formData
      })
      .then(response => {
        // console.log("后端响应状态:", response.status);
        if (!response.ok) {
          throw new Error('语音识别请求失败');
        }
        return response.json();
      })
      .then(data => {
        // console.log("后端返回数据:", data);
        if (data.success === true && data.text && data.text.trim()) {
          setRecognizedText(data.text);
          setShowTextInputAfterVoice(true);
          setIsVoiceMode(false);
        } else {
          showToast(i18n.language === 'zh' ? '未识别到语音' : 'No voice detected');
        }
      })
      .catch(error => {
        // console.error('语音识别错误:', error);
        showToast(i18n.language === 'zh' ? '语音解析失败' : 'Failed to parse voice');
      });

      setSendAudio(false);
      setAudioChunks([]);
    }
  }, [sendAudio, audioChunks, user]);

  const recorder = {
    canRecord: true,
    volume: 0.8,
    onStart:() => startRecording(), // 开始录音回调
    onCancel: () => {cancelRecording();},  // 取消录音回调
    onEnd: () => {
      if (swipeUpToCancel) {
        cancelRecording();
        setSwipeUpToCancel(false);
        showToast(i18n.language === 'zh' ? '已取消发送' : 'Cancelled');
      } else {
        stopRecording();
      }
    } // 结束录音回调
  };
  const refresh = () => {
    if (!hasMoreHistory) {
      return new Promise(()=>{})
    }
    // 获取历史消息
    return fetch(baseUrl+"/api/history", {
      method: "post",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': user.token
      },
      body: JSON.stringify({
        user: user.userId,
        chatbot: bot_list[botNumber],
        conversation_id: window.localStorage.getItem("conversation-id-"+bot_list[botNumber])
      })
    }).then(response => {
        if (!response.ok) {return;}
        response.json().then(data=>{
          console.log(data);
          const historyMsg = []
          for(let i=0; i<data.data.length;i++) {
            historyMsg.push({
              type: "text",
              position: 'right',
              content: {text: data.data[i].query}
            });
            historyMsg.push({
              type: 'text',
              content: { text: data.data[i].answer},
              position: 'left',
              user: assistantInfo
            })
          }
          prependMsgs(historyMsg)
        });
    })
    .catch(error=> {
      console.log("error: " + error);
    })

  }

  // 获取工单信息的函数
  const fetchWorkOrders = (eventType = '', status = '') => {
    // console.log("user id: "+user.merchantId, "token: "+user.token);
    return fetch(baseUrl + '/backend-api/get-work-orders', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': user.token
      },
      body: JSON.stringify({
        // userId: 461,//user.merchantId
        orderType: eventType,
        status: status
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch work orders');
      }
      return response.json();
    })
    .then(data => {
      console.log('Work orders data:', data);
      return data;
    })
    .catch(error => {
      console.error('Error fetching work orders:', error);
      // 返回模拟数据以防接口调用失败
      return {
        success: true,
        data: []
      };
    });
  };

  const inputRef = useRef(null);
  const fileInputRef = useRef(null);
  const cameraInputRef = useRef(null);

  // 检测是否是iOS设备
  useEffect(() => {
    const checkIOS = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /iPhone|iPad|iPod/i.test(userAgent);
    };
    setIsIOS(checkIOS());
  }, []);

  // 滚动到底部的辅助函数
  const scrollMessageContainerToBottom = () => {
    const messageContainer = document.querySelector('.chat-content-wrapper .MessageContainer');
    if (messageContainer) {
      messageContainer.scrollTop = messageContainer.scrollHeight;
    }
  };

  // 跟踪消息数量，用于检测新消息
  const prevMessagesLengthRef = useRef(0);
  const isInitialMountRef = useRef(true);

  // 初始加载时滚动到底部显示最新消息
  useEffect(() => {
    if (isInitialMountRef.current && messages.length > 0) {
      // 组件挂载后滚动到底部，延迟确保 DOM 已渲染
      setTimeout(() => {
        scrollMessageContainerToBottom();
        // 再次确保，因为 DOM 可能还没完全渲染
        requestAnimationFrame(() => {
          scrollMessageContainerToBottom();
        });
        isInitialMountRef.current = false;
        prevMessagesLengthRef.current = messages.length;
      }, 300);
    }
  }, []); // 只在组件挂载时执行一次

  // 当有新消息添加时，自动滚动到底部（如果用户已经在底部附近）
  useEffect(() => {
    // 跳过初始加载
    if (isInitialMountRef.current) {
      prevMessagesLengthRef.current = messages.length;
      return;
    }

    // 检测是否有新消息添加（消息数量增加）
    if (messages.length > prevMessagesLengthRef.current) {
      const messageContainer = document.querySelector('.chat-content-wrapper .MessageContainer');
      if (messageContainer) {
        // 检查用户是否在底部附近（距离底部100px以内）
        const isNearBottom = messageContainer.scrollHeight - messageContainer.scrollTop - messageContainer.clientHeight < 100;
        
        // 如果用户在底部附近，或者这是用户发送的消息，自动滚动到底部
        const lastMessage = messages[messages.length - 1];
        const isUserMessage = lastMessage && lastMessage.position === 'right';
        
        if (isNearBottom || isUserMessage) {
          // 延迟滚动，确保 DOM 已更新
          setTimeout(() => {
            scrollMessageContainerToBottom();
          }, 50);
        }
      }
    }
    
    // 更新消息数量
    prevMessagesLengthRef.current = messages.length;
  }, [messages]);

  // 使用useEffect将图片预览区域插入到ChatFooter组件内部
  useEffect(() => {
    if (pendingFiles.length > 0) {
      // 查找ChatFooter组件
      const chatFooterElement = document.querySelector('.ChatFooter');
      if (chatFooterElement) {
        // 查找或创建图片预览容器
        let previewContainer = chatFooterElement.querySelector('.image-preview-container');
        
        if (!previewContainer) {
          // 创建图片预览容器
          previewContainer = document.createElement('div');
          previewContainer.className = 'image-preview-container';
          previewContainer.style.cssText = `
            padding: 10px 15px;
            borderBottom: 1px solid #eee;
            display: flex;
            flexWrap: wrap;
            gap: 10px;
            backgroundColor: #f9f9f9;
          `;
          
          // 将预览容器插入到ChatFooter内部的第一个位置
          chatFooterElement.insertBefore(previewContainer, chatFooterElement.firstChild);
        }
        
        // 清空现有内容
        previewContainer.innerHTML = '';
        
        // 添加文件预览
        pendingFiles.forEach((file, index) => {
          const imageWrapper = document.createElement('div');
          imageWrapper.style.cssText = `
            position: relative;
            max-width: 80px;
            max-height: 80px;
            width: 80px;
            height: 80px;
            borderRadius: 8px;
            overflow: hidden;
            border: 1px solid #ddd;
          `;
          
          const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'];
          const fileExtension = file.name.split('.').pop().toLowerCase();
          
          if (imageExtensions.includes(fileExtension)) {
            // 图片预览
            const img = document.createElement('img');
            img.src = file.localUrl;
            img.style.cssText = `
              width: 100%;
              height: 100%;
              object-fit: cover;
            `;
            imageWrapper.appendChild(img);
          } else {
            // 文档预览
            const docPreview = document.createElement('div');
            docPreview.style.cssText = `
              width: 100%;
              height: 100%;
              backgroundColor: #f0f0f0;
              display: flex;
              align-items: center;
              justify-content: center;
              fontSize: 14px;
              color: #666;
              fontWeight: bold;
            `;
            docPreview.textContent = `.${fileExtension}`;
            imageWrapper.appendChild(docPreview);
          }
          
          const deleteBtn = document.createElement('div');
          deleteBtn.innerHTML = '×';
          deleteBtn.style.cssText = `
            position: absolute;
            top: 0;
            right: 0;
            width: 30px;
            height: 30px;
            fontSize: 30px;
            borderRadius: 50%;
            backgroundColor: rgba(0,0,0,0.6);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            fontWeight: bold;
          `;
          deleteBtn.onclick = () => removePendingImage(index);
          
          imageWrapper.appendChild(deleteBtn);
          
          // 如果文件正在上传，添加上传状态指示器
          if (file.uploading) {
            const uploadingIndicator = document.createElement('div');
            uploadingIndicator.style.cssText = `
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              fontSize: 30px;
              backgroundColor: rgba(255,255,255,0.7);
              display: flex;
              align-items: center;
              justify-content: center;
            `;
            
            const spinner = document.createElement('div');
            spinner.style.cssText = `
              width: 24px;
              height: 24px;
              border: 2px solid #3498db;
              borderTop: 2px solid transparent;
              border-radius: 50%;
              animation: spin 1s linear infinite;
            `;
            
            uploadingIndicator.appendChild(spinner);
            imageWrapper.appendChild(uploadingIndicator);
          }
          
          previewContainer.appendChild(imageWrapper);
        });
      }
    } else {
      // 如果没有待发送图片，移除预览容器
      const previewContainer = document.querySelector('.ChatFooter .image-preview-container');
      if (previewContainer) {
        previewContainer.remove();
      }
    }
  }, [pendingFiles]);

  // 监听输入框焦点和输入事件，自动折叠/展开 banner
  useEffect(() => {
    const handleInputFocus = (e) => {
      // 检查是否是聊天输入框元素（在 Composer 组件内）
      const target = e.target;
      if (target && (target.tagName === 'TEXTAREA' || (target.tagName === 'INPUT' && target.type === 'text'))) {
        // 检查是否在聊天输入框区域内
        const composer = target.closest('.Composer, [class*="Composer"]');
        if (composer) {
          setBannerVisible(false);
        }
      }
    };

    const handleInput = (e) => {
      // 当用户输入文字时，隐藏 banner
      const target = e.target;
      if (target && (target.tagName === 'TEXTAREA' || (target.tagName === 'INPUT' && target.type === 'text'))) {
        // 检查是否在聊天输入框区域内
        const composer = target.closest('.Composer, [class*="Composer"]');
        if (composer) {
          // 只要输入框有内容（包括空格），就隐藏 banner
          if (target.value && target.value.length > 0) {
            setBannerVisible(false);
          }
        }
      }
    };

    const handleClick = (e) => {
      // 当用户点击聊天区域内的任何交互元素时，隐藏 banner
      const target = e.target;
      // 检查是否点击了菜单项、按钮或其他交互元素
      const isInteractiveElement = target.closest('.menu, .menu-card, .my-list-item, button, [role="button"], .ListItem, [class*="Card"]');
      // 检查是否在聊天内容区域内（排除导航栏和 banner 本身）
      const isInChatArea = target.closest('.chat-content-wrapper, .MessageContainer, .ChatApp');
      // 排除 banner 和下拉按钮的点击
      const isBannerElement = target.closest('.chat-banner, .banner-toggle-btn');
      
      if (isInteractiveElement && isInChatArea && !isBannerElement) {
        setBannerVisible(false);
      }
    };
    
    // 使用事件委托，监听整个文档的焦点、输入和点击事件
    document.addEventListener('focusin', handleInputFocus);
    document.addEventListener('input', handleInput);
    document.addEventListener('click', handleClick, true); // 使用捕获阶段确保能捕获到所有点击

    return () => {
      document.removeEventListener('focusin', handleInputFocus);
      document.removeEventListener('input', handleInput);
      document.removeEventListener('click', handleClick, true);
    };
  }, []); // 只需要在组件挂载时绑定一次
  
  const setInputText = (text) => {
    if (inputRef.current) {
      inputRef.current.setText(text);
    }
  };

  // 处理选择图片
  const handleSelectImage = () => {
    setOpenComposer(false);
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // 处理文件选择
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    // 验证文件类型
    const allowedExtensions = {
      image: ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'],
      document: ['txt', 'doc', 'docx', 'pdf', 'md', 'csv', 'xls', 'xlsx']
    };
    
    const fileName = file.name.toLowerCase();
    const fileExtension = fileName.split('.').pop();
    
    // 检查文件是否在允许的类型列表中
    const fileType = allowedExtensions.image.includes(fileExtension) ? 'image' : 
                    allowedExtensions.document.includes(fileExtension) ? 'document' : null;
    
    if (!fileType) {
      alert('不支持的文件类型，请选择图片或文档文件');
      return;
    }
    
    // 创建本地预览URL
    const reader = new FileReader();
    reader.onload = (e) => {
      const localUrl = e.target.result;
      
      // 添加本地预览到待发送文件数组，不上传到服务器
      setPendingFiles(prevFiles => [...prevFiles, {
        localUrl: localUrl,
        serverUrl: null,
        uploading: false,
        file: file,
        name: file.name
      }]);
    };
    reader.readAsDataURL(file);
    
    // 重置input，以便可以再次选择同一文件
    event.target.value = '';
  };

  // 处理拍照
  const handleTakePhoto = () => {
    setOpenComposer(false);

    try {
      if (cameraInputRef.current) {
        // 在iOS webview中，直接调用click可能导致崩溃，使用setTimeout延迟执行
        setTimeout(() => {
          try {
            cameraInputRef.current.click();
          } catch (error) {
            console.error('拍照功能错误:', error);
            // 如果相机调用失败，回退到普通文件选择
            if (fileInputRef.current) {
              fileInputRef.current.click();
            }
          }
        }, 100);
      }
    } catch (error) {
      console.error('拍照功能初始化错误:', error);
      // 如果相机调用失败，回退到普通文件选择
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    }

  };

  // 处理语音输入
  const handleVoiceInput = () => {
    setOpenComposer(false);
    // TODO: 实现语音输入功能
    // 需要切换到录音模式并触发 Recorder-btn
    setIsVoiceMode(true);
  };

  const handleCancelVoice = () => {
    setIsVoiceMode(false);   // 返回普通输入框
    setShowTextInputAfterVoice(false);
    setRecognizedText('');
    cancelRecording();        // 停止并清理录音
  };
  // 处理相机文件选择
  const handleCameraChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      // 创建本地预览URL
      const reader = new FileReader();
      reader.onload = (e) => {
        const localImageUrl = e.target.result;
        
        // 添加本地预览到待发送文件数组，不上传到服务器
        setPendingFiles(prevFiles => [...prevFiles, {
          localUrl: localImageUrl,
          serverUrl: null,
          uploading: false,
          file: file,
          name: file.name
        }]);
      };
      reader.readAsDataURL(file);
    }
    // 重置input，以便可以再次选择同一文件
    event.target.value = '';
  };

  // 如果当前页面是Activities，显示Activities组件
  if (currentPage === 'activities') {
    return (
      <div style={{'display': 'block', 'width': '100%', 'height': '100%', 'position': 'relative'}}>
        <Activities onBack={handleBackToChat} fetchWorkOrders={fetchWorkOrders} />
      </div>
    );
  }

  // 如果当前页面是Marketplace，显示Marketplace组件
  if (currentPage === 'marketplace') {
    return (
      <div style={{'display': 'block', 'width': '100%', 'height': '100%', 'position': 'relative'}}>
        <Marketplace onBack={handleBackToChat} user={user} />
      </div>
    );
  }

  // 如果当前页面是Settings，显示Settings组件
  if (currentPage === 'settings') {
    return (
      <div style={{'display': 'block', 'width': '100%', 'height': '100%', 'position': 'relative'}}>
        <Settings 
          onBack={handleBackToChat} 
          user={user}
          onLogout={handleLogout}
          onDeleteAccount={handleDeleteAccount}
        />
      </div>
    );
  }

  // 如果当前页面是管理店铺，显示管理店铺组件
  if (currentPage === 'manageStore') {
    return (
      <ManageStore 
        user={user}
        merchantInfo={merchantInfo}
        merchantInfoError={merchantInfoError}
        onBack={()=>setCurrentPage('profile')}
        onLoadMerchantInfo={loadMerchantInfo}
        onFetchGoodsList={fetchGoodsListForManageStore}
      />
    );
  }

  // 如果当前页面是Profile，显示Profile组件
  if (currentPage === 'profile') {
    return (
      <div style={{'display': 'block', 'width': '100%', 'height': '100%', 'position': 'relative'}}>
        <Profile 
          onBack={handleBackToChat} 
          user={user}
          merchantInfo={merchantInfo}
          merchantInfoError={merchantInfoError}
          onLogout={handleLogout}
          onDeleteAccount={handleDeleteAccount}
          onManageStore={handleManageStoreClick}
          onLoadMerchantInfo={loadMerchantInfo}
        />
      </div>
    );
  }

  return (
    <div className={`chat-window-container ${!bannerVisible ? 'banner-hidden' : ''}`}>
        {/* 背景图 */}
        <div 
          className="chat-background"
          style={{
            backgroundImage: 'url(/images/backend.png)'
          }}
        ></div>
        
        {/* Banner图 */}
        <div 
          className={`chat-banner ${bannerVisible ? 'banner-visible' : 'banner-hidden'}`}
          style={{
            backgroundImage: 'url(/images/banner.png)'
          }}
        >
          {/* 下拉按钮 - 当 banner 隐藏时显示 */}
          {!bannerVisible && (
            <button 
              className="banner-toggle-btn"
              onClick={() => setBannerVisible(true)}
              aria-label="展开 Banner"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          )}
        </div>
        
        <div className="chat-content-wrapper">
          {/* 弹窗组件 */}
          <Popup
            active={modalOpen}
            title="Review"
            onClose={() => setModalOpen(false)}
            height={80}
            actions={[
              {
                label: 'Submit',
                color: 'primary',
                onClick: () => {
                  // 处理表单提交
                  console.log('Submit fields:', modalFields);
                  setModalOpen(false);
                }
              }
            ]}
          >
            <div className="base-draft-card-container">
              {modalFields.map((field, index) => (
                <BaseComposer
                  key={index}
                  name={field.name}
                  type={field.type}
                  value={field.value}
                  setValue={(value) => handleFieldChange(index, value)}
                  description={field.description}
                  language="en_us"
                  format={field.format}
                />
              ))}
            </div>
          </Popup>
          
          {/* 注册成功弹窗 */}
          <Popup
            active={registerSuccessPopupOpen}
            title="注册成功"
            onClose={() => setRegisterSuccessPopupOpen(false)}
            height={60}
            backdrop={true}
            showClose={true}
            actions={[
              {
                label: '确定',
                color: 'primary',
                onClick: () => {
                  setRegisterSuccessPopupOpen(false);
                }
              }
            ]}
          >
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ fontSize: '24px', marginBottom: '16px' }}>🎉</div>
              <p style={{ fontSize: '18px', marginBottom: '8px' }}>提交成功！</p>
              <p style={{ color: '#666' }}>客服会尽快处理您的注册需求</p>
            </div>
          </Popup>

          <div style={{'display': 'block', 'width': '100%', 'height': '100%', 'position': 'relative'}}>
            {/* 自定义Apps按钮 */}
            {/* <div 
              className="custom-apps-button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setAppsMenuOpen(!appsMenuOpen);
                setBannerVisible(false);
              }}
              style={{
                position: 'absolute',
                top: '12px',
                right: '12px',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                zIndex: 100,
                backgroundColor: 'transparent',
                borderRadius: '4px'
              }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
            </div> */}
            
            <Chat
                messagesRef={msgRef}
              navbar={{
                // logo:"//gw.alicdn.com/imgextra/i4/O1CN016i66TT24lRwUecIk5_!!6000000007431-2-tps-164-164.png_80x80.jpg",
                title:"12POP",
                // desc:"hot line: +86 12345678910", //
                leftContent:{ 
                  icon: 'ellipsis-h', 
                  onClick: ()=>handleLeftClick()
                },
                rightContent: !user? [
                  { 
                    icon: 'warning-circle-fill',
                    onClick: () => setLoginTipModalOpen(true)
                  }
                ]: undefined,
                align:"left" }}
              placeholder={t('chat.inputPlaceholder', '请输入...')}
              messages={messages}
              renderMessageContent={renderMessageContent}
              // quickReplies={defaultQuickReplies}
              onQuickReplyClick={handleQuickReplyClick}
              // onSend={handleSend}
              onSend={handleSendToNewApi}
              locale={i18n.language === 'zh' ? 'zh-CN' : 'en-US'}
              // toolbar={toolbar}
              rightAction={user?{ icon: 'plus', onClick: ()=>{setOpenComposer(!openComposer)}}:null}
              // recorder={recorder}
              // onRefresh={refresh}
              recorder={isVoiceMode ? recorder : {}}
              onRefresh={isVoiceMode ? handleCancelVoice : undefined}
              composerRef={inputRef}
            >
            </Chat>
          </div>
          
          {/* Apps下拉菜单 */}
          {appsMenuOpen && (
            <div className="apps-dropdown-menu">
              <div className="apps-menu-item" onClick={handleMd5Encrypt}>
                <span className="apps-menu-icon">🔐</span>
                <span className="apps-menu-text">MD5加密</span>
              </div>
              {/* 可以在这里添加更多工具项 */}
              <div className="apps-menu-item">
                <span className="apps-menu-icon">🔧</span>
                <span className="apps-menu-text">更多工具</span>
              </div>
            </div>
          )}
          
          {/* MD5加密弹窗 */}
          <Popup
            active={md5ModalOpen}
            title="MD5加密工具"
            onClose={() => {
              setMd5ModalOpen(false);
              setMd5InputText('');
            }}
            height={50}
            backdrop={true}
            showClose={true}
            actions={[
              {
                label: '加密并复制',
                color: 'primary',
                onClick: handleEncryptAndCopy
              }
            ]}
          >
            <div style={{ padding: '20px 0' }}>
              <div style={{ marginBottom: '15px', fontSize: '16px' }}>
                要加密的文本:
              </div>
              <textarea
                value={md5InputText}
                onChange={(e) => setMd5InputText(e.target.value)}
                placeholder="请输入要加密的文本"
                style={{
                  width: '100%',
                  height: '100px',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  resize: 'none',
                  fontSize: '14px'
                }}
              />
            </div>
          </Popup>
          
          {/* 登录提示弹窗 */}
          <Modal
            active={loginTipModalOpen}
            title={t('chat.loginTipTitle', '温馨提示')}
            onClose={() => {
              setLoginTipModalOpen(false);
            }}
            actions={[{ label: '前往登录', color: 'primary' ,onClick: () => {
                    setLoginTipModalOpen(false);
                    setSidebarOpen(true);
                    setAuthModalOpen(true);}}]}
            vertical={false}

          >
            <div style={{ padding: '20px 0' }}>
              <p style={{ marginBottom: '20px', fontSize: '20px', lineHeight: '1.6' }}>
                {t('chat.loginTipContent', '登录后可使用更多功能，包括：')}
              </p>
              <ul style={{ marginBottom: '20px', paddingLeft: '20px', fontSize: '18px', lineHeight: '1.8' }}>
                <li>{t('chat.loginTipFeature1', '上传图片识别商品')}</li>
                <li>{t('chat.loginTipFeature2', '查看和管理历史对话')}</li>
                <li>{t('chat.loginTipFeature3', '使用促销活动功能')}</li>
                <li>{t('chat.loginTipFeature4', '管理店铺信息')}</li>
                <li>...</li>
              </ul>
              {/* <div style={{ textAlign: 'center', marginTop: '30px' }}>
                <button 
                  style={{
                    padding: '12px 32px',
                    backgroundColor: '#111827',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '15px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  onClick={}
                >
                  {t('chat.loginNow', '立即登录')}
                </button>
              </div> */}
            </div>
          </Modal>
        {/* {user? ( */}
        <InputComposer
            active={openComposer}
            composers={[
                // {label: t('chat.composer.takePhoto', '拍照'), desc: t('chat.composer.takePhotoDesc', '拍摄商品照片，AI自动生成促销活动'), icon: "camera", onClick: handleTakePhoto},
                {label: t('chat.composer.selectImage', '选择图片'), desc: t('chat.composer.selectImageDesc', '从相册选择，AI识别商品并生成促销内容'), icon: "image", onClick: handleSelectImage},
                {label: t('chat.composer.voiceInput', '语音输入'), desc: t('chat.composer.voiceInputDesc', '说出您的促销想法，AI自动整理'), icon: "mic", onClick: handleVoiceInput}
            ]}
            >
        </InputComposer>
        {/* ):(<></>)} */}
        {/* 隐藏的文件输入用于选择图片 */}
        <input
          type="file"
          ref={fileInputRef}
          accept="image/*"
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
        {/* 隐藏的文件输入用于拍照（使用相机） */}
        <input
          type="file"
          ref={cameraInputRef}
          accept="image/*"
          capture={isIOS ? undefined : "environment"}
          style={{ display: 'none' }}
          onChange={handleCameraChange}
        />
        <Sidebar 
          isOpen={sidebarOpen} 
          onClose={handleSidebarClose}
          user={user}
          onLogin={handleLoginClick}
          onLogout={handleLogout}
          onDeleteAccount={handleDeleteAccount}
          onActivities={handleActivitiesClick}
          onMarketplace={handleMarketplaceClick}
          onSettings={handleSettingsClick}
          onProfile={handleProfileClick}
          conversations={conversations}
          currentConversationId={currentConversationId}
          onSelectConversation={handleSelectConversation}
          onDeleteConversation={handleDeleteConversation}
          onNewChat={handleNewChat}
        />
        <AuthModal
          isOpen={authModalOpen}
          onClose={handleAuthModalClose}
          onLogin={handleLogin}
          onRegister={handleRegister}
        />
        </div>
        </div>
  );
};

export default ChatWindow;
